<template>
  <!-- 积分竞拍-->
  <div class="gift_list">
    <template v-if="createStep == 1">
        <div v-if="statisType == 1 && !detailStatus">
          <jd-subTab :options="tabSwitchListData" @input="handleTab" :value="currIndex" class="mb16">
          </jd-subTab>
        </div>
        <jd-form
          ref="inputFormRef"
          v-if="inputShow && !detailStatus"
          :formData.sync="formList"
          :formInfo="inputData"
          :immediately="true"
          :emitReset="true"
          @search="searchForm"
          @reset="handleReset"
          @selectChange="handleSelectChange"
        ></jd-form>
        <!-- 兑换详情列表 -->
        <jd-form
          ref="detailFormRef"
          v-if="inputShow && detailStatus"
          :formInfo="inputData2"
          :formData.sync="formList2"
          @search="searchForm2"
        ></jd-form>
        <jd-form v-if="inputShow1" :formInfo="inputData1"  style="margin-top: 20px;" @search="searchForm"></jd-form>
      <!-- 头部表单查询 -->
      <div class="mt16">
        <div class="top-wrap" v-if="statisType == 1">
          <div class="top-wrap-left">
            <div v-if="detailStatus">
              <jd-button
                type="blueLine"
                style="margin-right:8px"
                @click="addCrowd(11)"
                >按查询结果生成人群</jd-button
              >
              <jd-button
                style="margin-right:8px"
                @click="batchMarkForShipment"
                v-preventReClick
                >批量标记发货</jd-button
              >
              <jd-button @click="control = true" v-preventReClick>导出</jd-button>
              <el-checkbox v-model="createByMe" style="margin-left: 20px;" @change="handleCreateByMe">我创建的</el-checkbox>
            </div>
            <div v-else>
              <jd-button
                type="blueLine"
                @click="handleToDecoration"
                >积分商城装修</jd-button
              >
            </div>
          </div>
          <div>
            <el-checkbox v-if="!detailStatus" v-model="createByMe" style="margin-right: 20px;" @change="handleCreateByMe">我创建的</el-checkbox>
            <jd-button @click="detailClick" type="blueText">{{detailStatus?'活动列表':'兑换明细'}}</jd-button>
         </div>
        </div>
        <div class="mt12">
          <jd-table
            v-if="!detailStatus"
            :loading="talbeLoading"
            :tableData="tableData"
            style="width: 100%;"
            :pageInfo="{
              pageNum: formList.current,
              pageSize: formList.size,
              noShow: false,
              total: totalNum,
            }"
             @handlePage="handlePages"
          >
            <el-table-column label="礼品名称" width="200">
              <template slot-scope="scope">
                <div class="activityName">
                      <span class="fs12">{{ scope.row.activityName }}</span>
                  <el-popover v-if="currIndex != 5"
                   placement="right-end"
                   :width="getPopoverWidth(scope.row.activityType)"
                   trigger="hover"
                   :height="700"
                    >
                    <!-- 下单有礼和满额有礼跨店扫描 -->
                    <jd-subTab
                      v-if="showCannel(scope.row.activityType)"
                      :options="tabSwitchListDatas" 
                      @input="handleTabs($event,scope.row)" 
                      :value="currIndexs">
                    </jd-subTab>
                    <div v-show="currIndexs == 0">
                      <p style="margin: 20px; text-align: center">
                        请用手机京东扫描下面二维码查看您店铺的活动详情
                      </p>
                      <qrcode-vue
                        class="qrcode"
                        :id="'qrcode' + scope.row.id"
                        :ref="'qrcode' + scope.row.id"
                        :size="qrcodeVue.size"
                        :value="scope.row.idUrl"
                        :logo="qrcodeVue.logo"
                        :bgColor="qrcodeVue.bgColor"
                        :fgColor="qrcodeVue.fgColor"
                        style="text-align: center"
                      ></qrcode-vue>
                      <div>
                        <p style="margin: 20px; text-align: center">
                          链接地址：<span style="color: #999999">(手机京东店铺中活动详情链接地址)</span>
                        </p>
                        <el-input
                          v-if="scope.row.pcUrl"
                          readonly
                          v-model="scope.row.pcUrl"
                         :style="`margin: 0 20px; width: ${getInputWidth(scope.row.activityType)}px`"
                        ></el-input>
                        <el-input
                          v-else
                          readonly
                          v-model="scope.row.idUrl"
                          :style="`margin: 0 20px; width: ${getInputWidth(scope.row.activityType)}px`"
                        ></el-input>
                        <el-button
                          type="primary"
                          v-clipboard:copy="scope.row.pcUrl || scope.row.idUrl"
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onError"
                          >复制</el-button
                        >
                        <el-button type="primary"  
                                   style="border-radius: 4px"
                                  @click="handleSrcImg(scope.row.id)">
                          下载二维码
                        </el-button>
                      </div>
                      <!-- 活动链接 -->
                     <div style="margin-top: 10px;margin-left: 17px;">
                     <span>活动短链接:</span>
                     <el-input
                        readonly
                        disabled
                        :value="scope.row.shortLink || '生成中...'"
                        :style="`margin: 0 5px; width:200px`"
                      ></el-input>&nbsp;&nbsp;&nbsp;&nbsp;
                      <el-button
                        type="primary"
                        style="border-radius: 4px"
                        v-clipboard:copy="scope.row.shortLink || scope.row.pcUrl || scope.row.idUrl"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                        >复制</el-button>
                    </div>






                    </div>
                    <!-- 店铺渠道 -->
                    <div v-show="currIndexs == 1" class="channelBox">
                      <div style="margin: 10px 0;">
                        <jd-tip>注:仅设置了多店铺的活动有数据，目前支持多店铺设置的玩法有：满额有礼、下单抽奖</jd-tip>
                      </div>
                      <jd-table 
                        key="channel-table"
                        :noShow="true"
                        :tableData="tableDatas"
                        :tableInfo="tableChannelInfo"
                        :loading="tableLodingCurrIndexOne"
                      >
                        <!-- 二维码列的插槽 -->
                        <template #qrCode="{ row }">
                          <!-- 表格显示用的小二维码 -->
                          <div class="qrcode-container" @mouseenter="showMask = row.id" @mouseleave="showMask = null">
                            <qrcode-vue class="qrcode" :id="'channelQrcode' + row.id" :ref="'qrcode' + row.id"
                              :size="40" :value="getLinkUrl(row)" :logo="qrcodeVue.logo" :bgColor="qrcodeVue.bgColor"
                              :fgColor="qrcodeVue.fgColor" style="text-align: center;margin-top: 10px;"></qrcode-vue>
                            <!-- 遮罩层 -->
                            <div v-if="showMask === row.id" class="qrcode-mask" @click="showQrcodeDialog(row)">
                              <i class="el-icon-zoom-in qrcode-zoom-icon"></i>
                            </div>
                          </div>
                          <!-- 下载用的大二维码（隐藏） -->
                          <qrcode-vue class="qrcode-download" :id="'channelQrcodeDownload' + row.id" :size="200"
                            :value="getLinkUrl(row)" :logo="qrcodeVue.logo" :bgColor="qrcodeVue.bgColor"
                            :fgColor="qrcodeVue.fgColor"
                            style="position: absolute; left: -9999px; top: -9999px;"></qrcode-vue>
                        </template>
                        <!-- 链接地址 -->
                        <template #linkUrls="{ row }">
                          <el-tooltip class="item" :content="getLinkUrl(row)" placement="top">
                            <div style="width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ getLinkUrl(row) }}</div>
                          </el-tooltip>
                        </template>
                        
                        <template #action="{ row }">
                          <jd-button type="blueText" @click="copyChannelUrl(getLinkUrl(row))">复制链接</jd-button>
                          <jd-button type="blueText"
                            @click="handleSrcImg(row.id, 'channel')">下载二维码</jd-button>
                        </template>
                      </jd-table>
                    </div>
                    <!-- 自定义渠道 -->
                    <div v-show="currIndexs == 2" class="channelBox">
                      <div style="margin: 10px 0;">
                        <jd-button type="blue" @click="handleAddChannel(scope.row.activityType)">添加渠道链接</jd-button>&nbsp;
                        <span>注:多渠道投放活动时可自定义生成渠道链接，后续可追踪不同渠道投放的数据。</span>
                      </div>
                      <jd-table 
                        key="channel-table"
                        :noShow="true"
                        :tableData="tableDatas2"
                        :tableInfo="tableChannelInfo"
                        :loading="tableLodingCurrIndexTwo"
                      >
                      <!-- 店铺名称列的插槽 -->
                      <template #shopName="{ row }">
                        {{ row.sellerLinkName || '店铺名称' }}
                      </template>
                      <!-- 链接地址列的插槽 -->
                      <template #linkUrls="{ row }">
                        <el-tooltip class="item" :content="getLinkUrl(row)" placement="top">
                          <div style="width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ getLinkUrl(row) }}</div>
                        </el-tooltip>
                      </template>

                      <!-- 二维码列的插槽 -->
                      <template #qrCode="{ row }">
                            <!-- 表格显示用的小二维码 -->
                           <div class="qrcode-container" @mouseenter="showMask = row.id" @mouseleave="showMask = null">
                            <qrcode-vue class="qrcode" :id="'selfQrcode' + row.id" :ref="'qrcode' + row.id"
                             :size="40" :value="getLinkUrl(row)" :logo="qrcodeVue.logo" :bgColor="qrcodeVue.bgColor"
                             :fgColor="qrcodeVue.fgColor" style="text-align: center;margin-top: 10px;"></qrcode-vue>
                           <!-- 遮罩层 -->
                           <div v-if="showMask === row.id" class="qrcode-mask" @click="showQrcodeDialog(row)">
                            <i class="el-icon-zoom-in qrcode-zoom-icon"></i>
                          </div>
                         </div>
                          <!-- 下载用的大二维码（隐藏） -->
                        <qrcode-vue class="qrcode-download" :id="'selfQrcodeDownload' + row.id" :size="200"
                          :value="getLinkUrl(row)" :logo="qrcodeVue.logo" :bgColor="qrcodeVue.bgColor"
                          :fgColor="qrcodeVue.fgColor"
                          style="position: absolute; left: -9999px; top: -9999px;"></qrcode-vue>
                      </template>
                       <!-- 操作列的插槽 -->
                      <template #action="{ row }">
                        <jd-button type="blueText" @click="copyChannelUrl(getLinkUrl(row))">复制链接</jd-button>
                        <jd-button type="blueText" @click="handleSrcImg(row.id, type = 'self')">下载二维码</jd-button>
                      </template>
                      </jd-table>
                    </div>    
                  <!-- 列表图片 -->
                       
                  <img
                      v-if="
                        scope.row.activityType != 13 &&
                        scope.row.activityType != 14 &&
                        scope.row.activityType != 15 &&
                        scope.row.activityType != 63
                      "
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/list_code.png"
                      alt="活动二维码"
                      class="code"
                      slot="reference"
                      @mouseenter="handlerMouseEnter(scope.row.id)"
                    />
                  </el-popover>
          
                </div>
              </template>
            </el-table-column>
<!-- 
            <el-table-column label="用户pin" prop="pin" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.pin || '用户pin' }}</span>
              </template>
            </el-table-column> -->

            <el-table-column label="礼品类型" prop="activityType" width="150">
              <template slot-scope="scope">
                <!-- <span>{{ scope.row.activityType == 9 ? "兑换实物" : "兑换优惠券" }}</span> -->
                <span>{{ scope.row.activityType | activityString }}</span>
              </template>
            </el-table-column>

            <el-table-column v-if="currIndex != 5" label="面值" prop="price">
              <!-- <template slot-scope="scope">
                    </template> -->
            </el-table-column>

            <el-table-column v-if="currIndex != 5" label="所需积分" width="150">
              <template #header>
                <span>所需积分</span> &nbsp;
                <span class="open" v-if="!tableOpenAll" @click="tableOpenAll = true">展开</span>
                <span class="stop" v-else @click="tableOpenAll = false">收起</span>
              </template>
              <template slot-scope="scope">
                <div v-if="!tableOpenAll">
                  <span v-if="scope.row.memberLevelPointsListVOS.length > 0">
                    {{
                      scope.row.memberLevelPointsListVOS.find(
                        (item) => item.allow === true
                      ).levelName
                    }}:
                    {{
                      scope.row.memberLevelPointsListVOS.find(
                        (item) => item.allow === true
                      ).point
                    }}
                  </span>
                </div>

                <div class="hoveTitleShowMore" v-else-if="tableOpenAll&&scope.row.memberLevelPointsListVOS.length > 0">
                  <template v-for="item in scope.row.memberLevelPointsListVOS">
                    <p v-if="item.allow" :key="item.level">
                      {{ item.levelName }}：{{ item.point }}
                    </p>
                  </template>
                </div>
              </template>
            </el-table-column>

            <el-table-column v-if="currIndex != 5" label="总数/已兑">
              <template slot-scope="scope">
                <span>{{ scope.row.num }}</span
                >/
                <span>{{ scope.row.sendNum }}</span>
              </template>
            </el-table-column>

            <el-table-column label="上下架时间" :width="currIndex != 5?220:''">
              <template slot-scope="scope">
                <div class="activityTime" v-if="currIndex != 5">
                  <span>上架: {{ scope.row.startTime }}</span>
                  <span>下架: {{ scope.row.endTime }}</span>
                  <span style="color: #2768FF;">{{ scope.row.days }}</span>
                </div>
                <div class="activityTime2" v-else>
                  <span>{{ scope.row.startTime?scope.row.startTime:"-" }}</span>
                  <span class="activityTime2_line fc3">至</span>
                  <span>{{ scope.row.endTime?scope.row.endTime:'-' }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="最后修改时间" prop="updateTime" width="200"> </el-table-column>
            <el-table-column v-if="currIndex != 5" label="状态" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1"> <i class="yellow-status-icon mr4"></i>待上架 </span>
                <span v-if="scope.row.status == 2"> <i class="green-status-icon mr4"></i>已上架 </span>
                <span v-if="scope.row.status == 3"> <i class="grey-status-icon mr4"></i>已下架 </span>
                <span v-if="scope.row.status == 7">
                  <el-tooltip class="item" effect="light" :content="scope.row.failReason" placement="top">
                    <i class="new-icon-box" style="margin: -2px 2px;"></i>
                  </el-tooltip>
                    活动异常
                </span>
              </template>
            </el-table-column>
            <el-table-column label="参与人数" width="120" prop="joinNum" v-if="currIndex != 5">
              <template slot-scope="scope">
                {{scope.row.joinNum || 0}}
              </template>
            </el-table-column>
            <el-table-column prop="isDisplay" width="200" v-if="currIndex!=5">
              <template #header>
                <span>是否在商城显示</span>
                <el-tooltip class="item" effect="light" content="开启后，会在积分商场列表显示" placement="top">
                  <i class="new-icon-box" style="margin: -2px 2px;"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <!-- 开关替换为文本按钮，点击打开显示配置弹窗 -->
                <el-button type="text" class="display-config-btn" @click="openDisplayConfigDialog(scope.row)">
                  {{ getDisplayConfigText(scope.row) }}
                </el-button>
              </template>
            </el-table-column>

            <el-table-column prop="sort" width="200" v-if="currIndex!=5">
              <template #header>
                <span>展示优先级</span>
                <el-tooltip class="item" effect="light" content="数字越小优先级越高，展示在越前面，优先级相同时，按最后修改时间最近优先展示；" placement="top">
                  <i class="new-icon-box" style="margin: -2px 2px;"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.sort" @change="handleChangeDisplayOrSort($event, scope.row,'sort')" :min="1"></el-input-number>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="220">
              <template slot-scope="scope">
                <div class="editList" v-if="currIndex != 5">
                  <jd-button type="blueText" v-if="scope.row.status == 1&&scope.row.activityType == 9" @click="modify(scope.row,'edit')"
                    >编辑</jd-button
                  >
                  <jd-button type="blueText" v-else-if="scope.row.status == 1&&scope.row.activityType != 9" v-zoom="{ from: pageName + '礼品列表', name: '编辑' }" @click="changeList(scope.row)"
                    >编辑</jd-button
                  >
                  <jd-button type="blueText" @click="scope.row.activityType == 9 ? modify(scope.row,'edit') : changeList(scope.row)" v-if="scope.row.status == 2">修改</jd-button>
                  <jd-button type="blueText" v-else-if="scope.row.status != 1" disabled>修改</jd-button>
                  <!-- <jd-button type="blueText" v-if="scope.row.status == 2 || scope.row.status == 3" @click="seeList(scope.row)">查看</jd-button> -->
                  <jd-button type="blueText" @click="seeList(scope.row,scope.row.activityType,true)">复制</jd-button>
                 
                  <jd-button type="blueText" @click="statisData(scope.row)">数据统计</jd-button>
                  <el-dropdown>
                    <jd-button type="blueText" class="ml14">更多</jd-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <jd-button type="blueText" :isZoom="true" :zForm="pageName + '礼品列表'" zname='删除' @click="deleteById(scope.row)">删除</jd-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <jd-button type="blueText" :isZoom="true" :zForm="pageName + '礼品列表'" zname='查看' @click="seeList(scope.row)">查看</jd-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <jd-button type="blueText" v-if="scope.row.status == 1" @click="updateList(scope.row)"
                          :isZoom="true" :zForm="pageName + '礼品列表'" zName='上架'>上架</jd-button>
                        <jd-button type="blueText" v-if="scope.row.status == 2" @click="updateList(scope.row)"
                          :isZoom="true" :zForm="pageName + '礼品列表'" zName='下架'>下架</jd-button>
                      </el-dropdown-item>
                      <el-dropdown-item v-if="scope.row.status == 2&&scope.row.activityType == 9">
                        <jd-button type="blueText" @click="addInventory(scope.row)">奖品库存</jd-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <jd-button type="blueText" @click="handleWhiteList(scope.row)">白名单</jd-button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-else>
                  <jd-button type="blueText" @click="editDraft(scope.row)">编辑</jd-button>
                  <jd-button type="blueText" @click="deleteById(scope.row)">删除</jd-button>
                </div>
              </template>
            </el-table-column>
          </jd-table>
          <!-- 兑换明细 -->
          <jd-table
            v-else
            :loading="talbeLoading2"
            :tableData="tableData2"
            style="width: 100%;"
            :pageInfo="{
              pageNum: formList2.current,
              pageSize: formList2.size,
              noShow: false,
              total: totalNum2,
            }"
             @handlePage="handlePages2"
          >
            <el-table-column label="用户昵称" prop="memberNick">
              <template slot-scope="scope">
                {{scope.row.memberNick}}
                </template>
            </el-table-column>
            <!-- 用户pin列，显示用户加密pin，无值时显示"-" -->
            <el-table-column label="用户pin" prop="pin" width="150">
              <template slot-scope="scope">
                {{ scope.row.chaosPin || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="中奖ID" prop="id"></el-table-column>
            <el-table-column label="礼品名称" prop="prizeName">
              <template slot-scope="scope">
                {{scope.row.prizeName}}
                </template>
            </el-table-column>


            <el-table-column label="礼品类型" prop="prizeType">
              <template slot-scope="scope">
                <!-- <span>{{ scope.row.activityType | activityString }}</span> -->
                <span v-if="scope.row.prizeType == 1">兑换优惠券</span>
                <span v-if="scope.row.prizeType == 2">京豆</span>
                <span v-if="scope.row.prizeType == 3">兑换实物</span>
                <span v-if="scope.row.prizeType == 4">店铺积分</span>
                <span v-if="scope.row.prizeType == 5">E卡</span>
                <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                <span v-if="scope.row.prizeType == 8">红包</span>
                <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                <span v-if="scope.row.prizeType == 10">
                  <span>{{ scope.row.activateType==2 ? '百度网盘' : '礼品卡' }}</span>
                </span>
                <span v-if="scope.row.prizeType == 11">积分加钱购</span>
              </template>
            </el-table-column>


            <el-table-column label="消耗积分"  prop="point">
            </el-table-column>


            <el-table-column label="兑换时间" width="200">
              <template slot-scope="scope">
                <div class="activityTime">
                  <span>{{ scope.row.exchangeTime }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="兑换状态">
              <template slot-scope="scope">
                <span v-if="scope.row.exchangeStatus == 1" 
                  >兑换成功</span
                >
                <span v-if="scope.row.exchangeStatus == 2" >
                  兑换失败
                </span>
                <span v-if="scope.row.exchangeStatus == 3" 
                  >领取成功</span
                >
                <span v-if="scope.row.exchangeStatus == 4" 
                  >已撤回</span
                >
                <span v-if="scope.row.exchangeStatus == 5" 
                  >移除令牌</span
                >
              </template>
            </el-table-column>
            <el-table-column label="发货状态" prop="deliveryStatus">
              <template slot-scope="scope">
                <span v-if="scope.row.deliveryStatus == 1" 
                  >待发货</span
                >
                <span v-if="scope.row.deliveryStatus == 2" >
                  已发货
                </span>
                <span v-if="scope.row.deliveryStatus == 3" 
                  >无需发货（非实物）</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="receiverName" label="收货人" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.prizeType == 1|| scope.row.prizeType == 2 || scope.row.prizeType == 5 || scope.row.prizeType == 8"> -</div>
                <div class="open" v-else>
                  {{ scope.row.receiverName }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.receiverName &&
                      scope.row.receiverName.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt1('receiverName', scope.row, scope.$index)
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <!-- 收件人手机号 -->
            <el-table-column
              prop="receiverMobile"
              label="收件人手机号"
              width="120"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.prizeType == 1|| scope.row.prizeType == 2 || scope.row.prizeType == 5 || scope.row.prizeType == 8"> -</div>
                <div class="open" v-else>
                  {{ scope.row.receiverMobile }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.receiverMobile &&
                      scope.row.receiverMobile.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt1('receiverMobile', scope.row, scope.$index)
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="receiverRegion" label="收货地区" width="250">
              <template slot-scope="scope">
                <div v-if="scope.row.prizeType == 1|| scope.row.prizeType == 2 || scope.row.prizeType == 5  || scope.row.prizeType == 8"> -</div>
                <div class="open" v-else>
                  {{ scope.row.receiverRegion ? scope.row.receiverRegion: "-" }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.receiverRegion &&
                      scope.row.receiverRegion.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt1('receiverRegion', scope.row, scope.$index)
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="receiverAddress" label="详细地址" width="250">
              <template slot-scope="scope">
                <div v-if="scope.row.prizeType == 1|| scope.row.prizeType == 2 || scope.row.prizeType == 5  || scope.row.prizeType == 8"> -</div>
                <div class="open" v-else>
                  {{ scope.row.receiverAddress }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.receiverAddress &&
                      scope.row.receiverAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt1('receiverAddress', scope.row, scope.$index)
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="billCode" label="快递单号">
            </el-table-column>
            <el-table-column label="操作" width="220">
              <template slot-scope="scope">
                <div v-if="scope.row.prizeType == 1|| scope.row.prizeType == 2 || scope.row.prizeType == 5 || scope.row.prizeType == 8 "></div>
                <div v-else-if="scope.row.prizeType == 11">
                  <jd-button type="blueText" @click="removeToken(scope.row)" :disabled="scope.row.exchangeStatus == 5">移除令牌</jd-button>
                  <jd-button type="blueText" @click="revocationAddMoneyGoods(scope.row)" :disabled="scope.row.exchangeStatus != 1">撤回奖品</jd-button>
                </div>
                <div v-else>
                  <jd-button v-if="scope.row.deliveryStatus == 1 && scope.row.exchangeStatus != 4" type="blueText" @click="changeShip(scope.row)">标记发货</jd-button>
                  <span v-else-if="scope.row.deliveryStatus == 1 && scope.row.exchangeStatus == 4" class="disabled-btn mr14">标记发货</span>
                  <jd-button v-else-if="scope.row.deliveryStatus == 2 && scope.row.exchangeStatus != 4" type="blueText" @click="cancelShip(scope.row)"> 取消发货 </jd-button>
                  <span v-else-if="scope.row.deliveryStatus == 2 && scope.row.exchangeStatus == 4" class="disabled-btn mr14">取消发货</span>
                  <jd-button type="blueText" @click="shipment(scope.row)" v-if="scope.row.exchangeStatus != 4"> 录入快递单号 </jd-button>
                  <span v-else class="disabled-btn mr14">录入快递单号</span>
                  <!-- B待发货和已发货都可撤回 -->
                   <template v-if="scope.row.prizeType == 3">
                    <jd-button v-if="(scope.row.deliveryStatus == 1 || scope.row.deliveryStatus == 2) && scope.row.exchangeStatus != 4" @click="revocationIntergralGoods(scope.row)" type="blueText"> 
                      撤回 
                    </jd-button>
                    <span v-else class="disabled-btn">撤回</span>
                   </template>
                </div>
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </div>

      
    </template>
    <!-- 编辑弹窗 -->
    <el-dialog title="详情" :visible.sync="dialogFormVis" width="1300px">
      <el-form :model="amendForm" label-width="130px" class="new-input-box" v-loading="laoding">
        <el-form-item label="礼品名称:" v-if="theSta == 1">
          <el-input disabled v-model="amendForm.activityName" maxlength="15" show-word-limit style="width: 320px"></el-input>
        </el-form-item>
        <!-- 活动对象 -->
        <informationForm
          v-if="dialogFormVis && amendForm.ruleDTO"
          :defaultActMember.sync="amendForm.ruleDTO.activityTargetType"
          :plusObject.sync="amendForm.ruleDTO.plusObject" 
          :isCheckOpenCardTime.sync="amendForm.ruleDTO.isCheckOpenCardTime" 
          :openCardStartTime.sync="amendForm.ruleDTO.openCardStartTime" 
          :openCardEndTime.sync="amendForm.ruleDTO.openCardEndTime" 
          :peopleSelected.sync="amendForm.peopleSelected"
          v-model="amendForm.ruleDTO"
          :activityId="9"
          :localStepNum="16"
          :isEdit="true"
          :disabled="true"
          :isDisableCond="true"
          :needNonMember="true"
          :showOpenCardTip="true"
          :basicInformation="false"
          :customerPaperwork="amendForm.customerPaperwork"
          isCrowdTextDisabled
          @handlCorwdTips="amendForm.customerPaperwork = $event;$forceUpdate()"
        >
        </informationForm>
        <template v-if="amendForm.activityType == 9 || amendForm.activityType == 30">
          <el-form-item label="参与条件：">
            <div>
              <el-radio-group
                v-model="amendForm.ruleDTO.exchangeConditions"
                :disabled="isDisabled"
              >
                <el-radio :label="0">满足参与身份即可参与</el-radio>
                <el-radio :label="1">先下单后参与</el-radio>
              </el-radio-group>
            </div>
            <div
              v-if="amendForm.ruleDTO.exchangeConditions == 1"
              class="mt16"
              style="padding: 20px 0; background-color: #f2f2f2"
            >
              <el-form-item label="下单时间：" required>
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="amendForm.ruleDTO.orderStartTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 150px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                    :disabled="isDisabled"
                  >
                  </el-date-picker>
                  <div class="time_to_text">至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="amendForm.ruleDTO.orderEndTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 160px; font-size: 12px"
                    class="time2"
                    :clearable="false"
                    :disabled="isDisabled"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="金额统计类型：" required>
                <el-radio-group
                  v-model="amendForm.ruleDTO.orderPaymentType"
                  :disabled="isDisabled"
                >
                  <el-radio :label="0">实付金额</el-radio>
                  <el-radio :label="1">订单金额</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="商品要求：" required>
                <div class="flexc-cen-x">
                  <el-radio-group
                    v-model="amendForm.ruleDTO.filterType"
                    :disabled="isDisabled"
                  >
                    <el-radio :label="0">全部商品</el-radio>
                    <el-radio :label="1">指定商品</el-radio>
                    <el-radio :label="2">排除商品</el-radio>
                  </el-radio-group>
                  <jd-button
                    class="ml12"
                    :disabled="amendForm.ruleDTO.filterType == 0 || isDisabled"
                    @click="selectGoodsState = true"
                  >
                    已选择{{
                      isDisabled
                        ? amendForm.ruleDTO.skuIdList &&
                          amendForm.ruleDTO.skuIdList.length
                        : itemListForFilter.length
                    }}个
                  </jd-button>
                </div>
                <div class="mt16" v-if="amendForm.ruleDTO.filterType != 0">
                  <el-select
                    v-model="amendForm.ruleDTO.filterSkuType"
                    :disabled="isDisabled"
                    placeholder="请选择"
                    style="width: 320px"
                  >
                    <template v-if="amendForm.ruleDTO.filterType == 1">
                      <el-option
                        label="只要订单包含指定商品就整单计算"
                        :value="0"
                      />
                      <el-option
                        label="仅统计订单内指定商品的金额和件数"
                        :value="1"
                      />
                    </template>
                    <template v-if="amendForm.ruleDTO.filterType == 2">
                      <el-option
                        label="只要订单包含指定商品就整单排除"
                        :value="0"
                      />
                      <el-option
                        label="仅统计订单内非排除商品的金额和件数"
                        :value="1"
                      />
                    </template>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="商品件数：">
                <el-input
                  v-model="amendForm.ruleDTO.itemLimitCount"
                  :disabled="isDisabled"
                  style="width: 120px"
                  placeholder="请输入"
                />
                <span class="ml6">件及以上</span>
              </el-form-item>
              <el-form-item label="订单金额：" required>
                <el-input
                  v-model="amendForm.ruleDTO.orderPaymentLimit"
                  :disabled="isDisabled"
                  style="width: 120px"
                  placeholder="请输入"
                />
                <span class="ml6">元及以上</span>
              </el-form-item>
              <el-form-item label="订单状态：" required>
                <el-radio-group
                  v-model="amendForm.ruleDTO.orderType"
                  :disabled="isDisabled"
                >
                  <el-radio :label="0">已付款</el-radio>
                  <el-radio :label="1">已完成</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="统计规则：" required>
                <el-radio-group
                  v-model="amendForm.ruleDTO.orderCountType"
                  :disabled="isDisabled"
                >
                  <el-radio :label="0">按单笔订单统计</el-radio>
                  <el-radio :label="1">按累计订单统计</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <el-form-item label="礼品名称:" v-if="theSta == 0">
          <el-input v-model="amendForm.activityName" maxlength="15" show-word-limit style="width: 320px"></el-input>
        </el-form-item>
        <el-form-item label="添加优惠券:" v-if="couponTxt.couponId">
          <div>
            <div class="couponContent">
              <div class="txtNum">
                ￥
                <span style="font-size: 36px; color: #0000ff">{{ couponTxt.discount }}</span>
              </div>
              <div class="txtSize">
                满 {{ couponTxt.quota }} 元可使用 <br />
                {{ couponTxt.bindType == 1 ? "店铺券" : "商品券" }}
              </div>
              <p class="time">有效期:{{ couponTxt.beginTime }}~{{ couponTxt.endTime }}</p>
              <!-- <div class="background"></div>
                <div class="btn">
                  <el-button @click="createActivity" type="primary" size="small"
                    >取消</el-button
                  >
                </div> -->
            </div>
            <p class="pContent">优惠券名称：<span class="spanContent">{{ couponTxt.name }}</span></p>
            <p class="pContent">发行量：<span class="spanContent">{{ couponTxt.num }}</span></p>
            <br />
            <p class="pContent">领券开始时间：<span class="spanContent">{{ couponTxt.takeBeginTime }}</span></p>
            <p class="pContent">领券结束时间：<span class="spanContent">{{ couponTxt.takeEndTime }}</span></p>
            <br />
            <p class="pContent">限领规则：<span class="spanContent">{{ couponTxt.takeRule == 5 ? "活动期间限领一张" : "每天限领一张" }}</span></p>
          </div>
        </el-form-item>
        <el-form-item label="礼品价值:" v-if="amendForm.activityType == 9 || amendForm.activityType != 55">
          <el-input disabled v-model="amendForm.price" show-word-limit style="width: 136px"></el-input><span class="fc3">&nbsp;元</span>
        </el-form-item>
        <el-form-item label="京东价:" v-if="amendForm.activityType == 55">
          <el-input disabled v-model="amendForm.price" show-word-limit style="width: 136px"></el-input><span class="fc3">&nbsp;元</span>
        </el-form-item>
        <el-form-item label="划线价:" v-if="amendForm.activityType == 55">
          <el-input disabled v-model="amendForm.price" show-word-limit style="width: 136px"></el-input><span class="fc3">&nbsp;元</span>
        </el-form-item>

        <el-form-item label="礼品图片:" v-if="amendForm.activityType != 10 && amendForm.activityType != 55">
          <img :src="amendForm.logo" style="width: 146px; height: 146px" />
          <p style="color: #fe4d45; font-size: 12px">
            建议尺寸：750*420像素，图片大小不能超过1.5MB，类型：JPG、PNG
          </p>
        </el-form-item>
        <el-form-item label="活动类型:">
          <el-radio-group v-model="amendForm.activityType" disabled>
            <el-radio :label="9" style="margin-right: 15px;margin-bottom: 15px;">积分兑换实物</el-radio>
            <el-radio :label="10" style="margin-right: 15px;margin-bottom: 15px;">积分兑换优惠券</el-radio>
            <el-radio :label="29" style="margin-right: 15px;margin-bottom: 15px;">积分兑换京豆</el-radio>
            <el-radio :label="30" style="margin-right: 15px;margin-bottom: 15px;">积分兑换E卡</el-radio>
            <el-radio :label="38" style="margin-right: 15px;margin-bottom: 15px;">积分兑换红包</el-radio>
            <el-radio :label="55" style="margin-right: 15px;margin-bottom: 15px;">积分加钱购</el-radio>
            <el-radio :label="58" style="margin-right: 15px;margin-bottom: 15px;">积分兑换爱奇艺会员</el-radio>
            <el-radio :label="59" style="margin-right: 15px;margin-bottom: 15px;">积分兑换PLUS会员</el-radio>
            <el-radio :label="60" style="margin-right: 15px;margin-bottom: 15px;">积分兑换礼品卡</el-radio>
            <el-radio :label="61" style="margin-right: 15px;margin-bottom: 15px;">积分兑换百度网盘</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="礼品价值:" v-if="amendForm.activityType == 9 || amendForm.activityType == 10">
          <el-input v-model="amendForm.price" style="width: 180px" disabled></el-input>
          <span class="fc3">&nbsp;元</span>
        </el-form-item>
        <el-form-item label="上下架时间:">
          <div class="my_select_time">
            <el-date-picker
              disabled
              v-model="amendForm.startTime"
              type="datetime"
              size="small"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 180px; font-size: 12px"
            >
            </el-date-picker>
            <span class="fc3"> 至 </span>
            <el-date-picker
              disabled
              v-model="amendForm.endTime"
              type="datetime"
              size="small"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 180px; font-size: 12px"
            >
            </el-date-picker>
          </div>
          <span class="lastTime fc3">
            活动持续
            <span style="color: #0000ff">{{ timeDay }}</span> 天
          </span>
        </el-form-item>
        <el-form-item label="最后修改时间:">
          <div class="my_select_time">
            <el-date-picker
              disabled
              v-model="amendForm.updateTime"
              type="datetime"
              size="small"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 180px; font-size: 12px"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="京豆套餐:" v-if="amendForm.activityType == 29 && amendForm.exchangeType == 1">
          <el-table
            :data="amendForm.exchangeSet"
            border
            style="width: 542px; border: 1px solid #f0f0f0"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column prop="singleNum" label="单个套餐京豆数量（个）">
              <template slot-scope="scope">
                <el-input v-model="scope.row.singleNum" disabled></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="套餐数量（个）">
              <template slot-scope="scope">
                <el-input v-model="scope.row.total" disabled></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="选择发豆账户:" v-if="amendForm.activityType == 29&&venderType">
          <el-select v-model="accountCode" placeholder="请选择" disabled>
            <el-option
              v-for="item in accountCodeList"
              :key="item.accountCode"
              :label="item.accountCode"
              :value="item.accountCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="次数限制:" v-if="amendForm.activityType == 29">
          <el-radio-group v-model="amendForm.ruleType" disabled>
            <el-radio :label="1">每人每日兑换次数</el-radio>
            <el-radio :label="2">每人活动内兑换次数</el-radio>
          </el-radio-group>
          <div>
            <el-input v-model="amendForm.limitVal" disabled placeholder="请输入" style="width: 120px"></el-input>
            次（最多20次）
          </div>
        </el-form-item>
        <el-form-item :label="amendForm.activityType == 9 ?'兑换次数限制:' : '每人限兑次数:'" v-if="(amendForm.activityType == 9 ) || amendForm.activityType == 10">
          <div class="limitBox">
            <span v-if="amendForm.activityType == 9">活动期间每人每天最多可兑换</span>
            <el-input placeholder="不限制" v-if="amendForm.activityType == 9" disabled v-model="amendForm.exchangeDayTimes" style="width: 100px;margin:0 6px;"></el-input>
            <span v-if="amendForm.activityType == 9">次，累计每人最多可兑换</span>
            <el-input placeholder="不限制" disabled v-model="amendForm.exchangeTimes" style="width: 100px;margin:0 6px;"></el-input>
            <span class="fc3">次</span>
            <!-- <p class="desc">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tips_2.svg"
                style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 9px 4px 0 3px;
                "
              />
              <span class="fc3">不填则默认不限</span>
            </p> -->
          </div>
        </el-form-item>
        <el-form-item :label="amendForm.activityType == 30 || activityTypeListAll.includes(amendForm.activityType) ? '兑换次数限制:' : '数量限制:'" v-else-if="amendForm.activityType != 9 && amendForm.activityType != 38 && amendForm.activityType != 55">
          <span> 活动期间每人每天最多可兑换</span>
          <el-input v-model="amendForm.exchangeDayNum" disabled placeholder="不限制" style="width: 136px;margin:0 5px;"></el-input>
          <span>次，累计每人最多可兑换</span>
          <el-input v-model="amendForm.exchangeNum" disabled placeholder="不限制" style="width: 136px;margin:0 5px;"></el-input>
          <span class="fc3">次</span>
        </el-form-item>
        <el-form-item label="发放数量:" v-if="[58,59].includes(amendForm.activityType)">
          <span>活动期间每日最多可兑换</span>
          <el-input v-model="amendForm.exchangeNumPerDay" disabled placeholder="请输入" style="width: 136px;margin:0 5px;"></el-input>
          <span>张，累计最多可兑换</span>
          <el-input v-model="amendForm.quantityTotal" disabled placeholder="请输入" style="width: 136px;margin:0 5px;"></el-input>张
        </el-form-item>

        <el-form-item :label="labelText" v-if="activityTypeListAll.includes(amendForm.activityType)">
            <el-select
              v-model="amendForm.itemId"
              style="width: 320px; margin-right: 10px"
              disabled
              @change="handlePrizeChange($event,1)"
              v-if="amendForm.activityType == 58 || amendForm.activityType == 59"
            >
              <el-option
                v-for="item in prizeMemberList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="amendForm.assetsId"
              style="width: 320px; margin-right: 10px"
              disabled
              @change="handlePrizeChange($event,2)"
              v-else-if="amendForm.activityType == 60 || amendForm.activityType == 61"
            >
              <el-option
                v-for="item in giftCardList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

        <el-form-item label="发行总量:" v-if="[60,61].includes(amendForm.activityType)" required>
          <el-input v-model="amendForm.quantityTotal" disabled placeholder="请输入" style="width: 136px;margin:0 5px;"></el-input>次
          <div v-if="amendForm.activityType == 60 || amendForm.activityType == 61">
            剩余 <span class="tip-color">{{ quantityBalance }}</span> 张
          </div>
        </el-form-item>


        <el-form-item label="兑换消耗:"  v-if="amendForm.activityType == 55">
          <el-input
            disabled
            v-model="amendForm.memberLevelPointsDTOList[0].point"
            style="width: 136px; margin-right: 10px"
          ></el-input
          >积分 +
          <el-input
            v-model="amendForm.payPrice"
            disabled
            style="width: 136px; margin-left: 10px"
          ></el-input
          >元
        </el-form-item>

        <!-- 每日最多可兑 -->
        <el-form-item label="选择E卡:" v-if="amendForm.activityType == 30">
          <el-select v-model="amendForm.itemId" placeholder="请选择" disabled>
            <el-option label="1元" value="2"></el-option>
            <el-option label="5元" value="3"></el-option>
            <el-option label="20元" value="4"></el-option>
            <el-option label="50元" value="5"></el-option>
            <el-option label="100元" value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="兑换次数限制:"  v-if="amendForm.activityType == 38">
          <div>
            <span> 每人每日兑换次数：</span>
            <el-input v-model="amendForm.exchangeDayTimes" placeholder="请输入" :disabled="true" style="width: 136px;margin:0 5px;"></el-input>
            <el-tooltip class="item" effect="light" content="每人每日兑换次数需≤20次，且不可超过每人活动内兑换次数设置数" placement="bottom">
              <el-button type="text" style="width: 35px;">
                <i class="el-icon-question" style="color:#ccc"></i>
              </el-button>
            </el-tooltip>
          </div>
          <div style="margin-top: 20px;">
            <span> 每人活动内兑换次数：</span>
            <el-input v-model="amendForm.exchangeTimes" placeholder="请输入" :disabled="true" style="width: 136px;margin:0 5px;"></el-input>
            <el-tooltip class="item" effect="light" content="每人活动内兑换次数需≤20次" placement="bottom">
              <el-button type="text" style="width: 35px;">
                <i class="el-icon-question" style="color:#ccc"></i>
              </el-button>
            </el-tooltip>
          </div>
        </el-form-item>
        <el-form-item label="红包份数限制:" v-if="amendForm.activityType == 38">
            <el-tooltip class="item" effect="light" content="每人每天兑换红包的份数设置，每天累计领取红包金额不超过10000元，单次可领取红包面额最大为4999元。" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question" style="color:#ccc"></i>
                </el-button>
            </el-tooltip>
            <div>
              <span> 每人每日兑换份数：</span>
              <el-input v-model="amendForm.exchangeDayNum" placeholder="请输入" disabled style="width: 136px;margin:0 5px;"></el-input>
            </div>
            <div style="margin-top: 20px;">
              <span> 每人活动内兑换份数：</span>
              <el-input v-model="amendForm.exchangeNum" placeholder="请输入" disabled style="width: 136px;margin:0 5px;"></el-input>
            </div>
        </el-form-item>

        <el-form-item label="红包有效期:"  v-if="amendForm.activityType == 38">
            <el-radio-group v-model="amendForm.redPacketExpiration" disabled>
              <el-radio :label="2">相对时间</el-radio>
              <el-radio :label="1">绝对时间</el-radio>
            </el-radio-group>
            <div v-if="amendForm.redPacketExpiration == 2">
              领取后 <el-input v-model="amendForm.effectiveDays" disabled style="width: 136px"></el-input
            > 天内有效
            </div>
            <div v-if="amendForm.redPacketExpiration == 1">
              <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="amendForm.startTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 135px; font-size: 12px"
                class="time1"
                :clearable="false"
                :disabled="true"
              >
              </el-date-picker>
              <div class="time_to_text fc3">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="amendForm.effectiveEndTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 150px; font-size: 12px"
                class="time2"
                :clearable="false"
                :disabled="true"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTime2()"></i>
              <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            </div>
        </el-form-item>

        <!-- redPrice -->
        <el-form-item label="单份红包金额:" v-if="amendForm.activityType == 38">
            <el-input v-model="amendForm.price"   
            disabled
            style="width: 136px"></el-input
            ><span class="fc3">&nbsp;元</span>
            <el-tooltip class="item" effect="light" content="单份红包设置：最大份额4999元，最小面额：1元" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question" style="color:#ccc"></i>
                </el-button>
            </el-tooltip>
        </el-form-item>
        <el-form-item v-if="!activityTypeListAll.includes(amendForm.activityType)" :label="amendForm.activityType == 29 || amendForm.activityType == 30 || amendForm.activityType == 38? '发放总量': amendForm.activityType == 55 ? '礼品兑换总量:' : '总份数:'">
          <template v-if="amendForm.activityType == 9">
            <span>活动期间每日最多可兑换</span>
            <el-input placeholder="不限制" disabled v-model="amendForm.exchangeNumPerDay" show-word-limit style="width: 100px;margin:0 6px;"></el-input>
            <span>次，累计每人最多可兑换</span>
          </template>
          <el-input disabled v-model="amendForm.quantityTotal" show-word-limit style="width: 100px;margin:0 6px;"></el-input>
         <span class="fc3">{{ amendForm.activityType == 29 ? "个" : amendForm.activityType == 30 ? "张" : "份" }}</span>
        </el-form-item>
        
        <el-form-item label="每日最多可兑:"  v-if="amendForm.activityType == 55">
              <el-radio-group v-model="amendForm.exchangePerDayLimit" disabled >
                <el-radio :label="0">不限制</el-radio>
                <el-radio :label="1">限制</el-radio>
              </el-radio-group>
              <el-input
                v-model="amendForm.exchangeNumPerDay"
                style="width: 136px; margin-left: 20px"
                disabled
              ></el-input
              >份
          </el-form-item>


        <!-- 会员兑换规则 -->
         <el-form-item label="会员兑换规则:" v-if="!activityTypeListAll.includes(amendForm.activityType)">
            <el-radio-group disabled v-model="amendForm.exchangeMemberTimes">
              <el-radio :label="1">活动期间可兑换1次</el-radio>
            </el-radio-group>
        </el-form-item>

        <!-- 令牌 -->
        <el-form-item label="选择令牌:" required v-if="amendForm.activityType == 55 && amendForm.promoTokenVO">
              <jd-button type="blue" disabled>选择令牌</jd-button>
              <div v-if="amendForm.promoTokenVO.tokenId">
                <div class="tokenDetial-item">
                  <span>令牌名称：</span>
                  <div class="flex-1">
                    {{ amendForm.promoTokenVO.name || "" }}
                  </div>
                </div>
                <div class="tokenDetial-item">
                  <span>令牌ID：</span>
                  <div class="flex-1">
                    {{ amendForm.promoTokenVO.tokenId || "" }}
                  </div>
                </div>
                <div class="tokenDetial-item">
                  <span>秘钥：</span>
                  <div class="flex-1">
                    {{ amendForm.promoTokenVO.secretKey || "" }}
                  </div>
                </div>
                <div class="tokenDetial-item">
                  <span>令牌有效时间：</span>
                  <div class="flex-1">
                    {{ amendForm.promoTokenVO.startTime + "-" + amendForm.promoTokenVO.endTime }}
                  </div>
                </div>
                <div class="tip-color">注意：促销有效时间等于令牌有效时间</div>
              </div>
        </el-form-item>



        <el-form-item label="兑换所需积分:" v-if="amendForm.activityType != 55">
          <div class="isLevelSet">
            <template>
              <ul class="levelList" v-for="(item, index) in memberLevelList" :key="index">
                <li class="item" v-if="item.allow == true" style="width: 240px">
                  {{ item.name }}
                  <el-input disabled v-model="item.point" placeholder="请输入..." style="width: 80px"></el-input>
                  <span class="fc3">&nbsp;积分</span>
                </li>
                <br />
              </ul>
            </template>
          </div>
        </el-form-item>
        <el-form-item label="规则说明:" v-if="theSta == 1">
          <el-input disabled v-model="amendForm.ruleDescription" placeholder="请输入内容" type="textarea" :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="规则说明:" v-if="theSta == 0">
          <el-input v-model="amendForm.ruleDescription" placeholder="请输入内容" type="textarea" :rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="theSta == 0">
        <el-button @click="dialogFormVis = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisB" v-loading="dialogFormBtnLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="身份验证"
      width="600px"
      :show-close="false"
      custom-class="system-dialog"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="form-box">
        <div class="form-item">
          <div class="item-label">手机号：</div>
          <div class="item-value">
            <el-input disabled placeholder="请输入..." v-model="phone" style="width: 280px"></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">验证码：</div>
          <div class="item-value">
            <el-input placeholder="请输入" v-model="code" style="width: 170px; margin-right: 12px"></el-input>
            <el-button type="primary" :disabled="codeDisabled" @click="getCodeInit">{{ codeMsg }}</el-button>
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <button class="keepBtn" @click="savePhone()">
          确定
        </button>
        <button class="backBtn" @click="visible = false">取消</button>
      </div>
    </el-dialog>

    <!-- 数据统计 -->
    <statistics v-if="createStep == 3 && !isNew" @returnStep="returnStep" @triggerVersion="triggerVersion" :rowData="rowData" :ids1="ids1"></statistics>
    <!-- 数据统计-新版 -->
    <statistics-new
      class="marginClass"
      style="background-color: #fff"
      v-if="createStep == 3 && isNew"
      @returnStep="returnStep"
      @triggerVersion="triggerVersion"
      :rowData="rowData"
      :ids1="ids1"
    ></statistics-new>
    <!-- 积分活动 -->
    <create-coupons
      ref="createStep13"
      :isShow="createStep == 13"
      v-if="createStep == 13"
      :stepNum="stepNum"
      :tabActive="activityData.activityType"
      :activityData="activityData"
      :valueRow="valueRow"
      :isDraftEdit="isDraftEdit"
      @return="returnStep1"
      :style="{'margin-top': top?'-70px':''}"
    ></create-coupons>
    <create-coupons2
      ref="createStep14"
      :isShow="createStep == 14"
      v-if="createStep == 14"
      :stepNum="stepNum"
      :tabActive="activityData.activityType"
      :activityData="activityData"
      :valueRow="valueRow"
      :isDraftEdit="isDraftEdit"
      @returnback="returnStep1"
      :style="{'margin-top': top?'-70px':''}"
    ></create-coupons2>
    <!-- 兑换红包 -->
    <create-exchange-cash-red
      ref="createStep38"
      :isShow="createStep == 38"
      v-if="createStep == 38"
      :stepNum="stepNum"
      :tabActive="activityData.activityType"
      :activityData="activityData"
      :valueRow="valueRow"
      :isDraftEdit="isDraftEdit"
      @returnback="returnStep1"
    ></create-exchange-cash-red>
    <!-- 积分机加钱购 -->
    <points-money-purchase
      ref="createStep55"
      :isShow="createStep == 55"
      v-if="createStep == 55"
      :stepNum="stepNum"
      :tabActive="activityData.activityType"
      :activityData="activityData"
      :valueRow="valueRow"
      :isDraftEdit="isDraftEdit"
      @returnback="returnStep1"
    ></points-money-purchase>
    <!-- 积分兑换礼品卡/爱奇艺/百度网盘/PLUS会员 -->
    <create-exchange-common
      ref="createStep58"
      :isShow="[58,59,60,61].includes(createStep)"
      v-if="[58,59,60,61].includes(createStep)"
      :stepNum="stepNum"
      :tabActive="activityData.activityType"
      :activityData="activityData"
      :valueRow="valueRow"
      :isDraftEdit="isDraftEdit"
      @returnback="returnStep1"
    ></create-exchange-common>
    <!-- 生成报表 -->  
    <generate 
      :control = 'control' 
      v-if="control" 
      @transData="(val) => (control = val)"
      @transData1 = 'savePhone'
    ></generate>
    <!-- 生成人群 -->
    <crowdDialog v-if="isShowCrowdDialog" 
      :isShowCrowdDialog="isShowCrowdDialog"
      :searchForm="{...formList2,venderId:this.venderId,dataFrom:2}" 
      :source="source"
      :activityType="-1"
      :defaultValue="true"
      defaultValueText="活动管理创建"
      @close="crowdClose" 
    />
    <!-- 批量标记发货 -->
    <batch-upload
      v-if="batchLockVisible"
      :visible="batchLockVisible"
      action="/jd-hd-web/PointActivityAnalyticController/markingSendStatusBatch/fileUpload"
      @close="batchLockClose"
    ></batch-upload>
    <!-- 录入快递单号 -->
    <el-dialog
      title="录入快递单号"
      width="480px"
      v-if="sendOutGoodsShow"
      :visible.sync="sendOutGoodsShow"
      @close="blankEnterCoutierNum"
      class="enter_coutier_num_dialog"
    >
      <el-form :model="sendOutGoodsForm" label-width="86px" class="new-input-box">
        <el-form-item label="快递单号：">
          <el-input
            placeholder=""
            v-model="enterCoutierNum"
            style="width: 250px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <jd-button @click="blankEnterCoutierNum">取消</jd-button>
        <jd-button type="blue" style="margin-left: 8px;" @click="goodsEnterCoutierSubmit">确定</jd-button>
    </span>
    </el-dialog>
    <integral-mall-decoration v-if="createStep=='decoration'&&isShowIntegral" @returnStep="returnStep"></integral-mall-decoration>
     <!-- 二维码弹窗 -->
    <show-image 
      :visible.sync="qrcodeDialogVisible"
      :qrcode-data="qrcodePreviewData">
    </show-image>
     <!-- 添加渠道链接弹窗 -->
    <jd-dialog
      title="添加渠道链接"
      :visible.sync="addChannelVisible"
      append-to-body
      width="400px"
      @comfirm="handleChannelSave"
      @close="addChannelVisible = false"
      :sureLoading="addChannelLoading"
    >
      <el-form class="new-input-box">
        <el-form-item label="渠道名称: " required>
          <el-input v-model="channelName" maxLength="15" placeholder="请输入渠道名称" class="w260"/>
        </el-form-item>
      </el-form>
    </jd-dialog>
    <!-- 增加奖品库存弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      :isExchangeAct="true"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 显示配置弹窗：配置积分商城显示时间规则 -->
    <el-dialog
      title="显示配置"
      :visible.sync="displayConfigVisible"
      width="560px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form :model="displayConfigForm" label-width="100px" class="new-input-box">
        <el-form-item label="显示时间：">
          <div class="display-time-radios">
            <el-radio v-model="displayConfigForm.displayType" :label="1">持续显示</el-radio>
            <el-radio v-model="displayConfigForm.displayType" :label="2">活动下架则不显示</el-radio>
            <el-radio v-model="displayConfigForm.displayType" :label="3">指定显示时间</el-radio>
            <el-radio v-model="displayConfigForm.displayType" :label="0">不显示</el-radio>
          </div>
        </el-form-item>
        <!-- 指定显示时间时展示日期范围选择 -->
        <el-form-item label="选择日期：" v-if="displayConfigForm.displayType === 3">
          <el-date-picker
            v-model="displayConfigDateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 420px;"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="displayConfigVisible = false">取 消</jd-button>
        <jd-button type="blue" :loading="displayConfigSaving" @click="saveDisplayConfig">保 存</jd-button>
      </div>
    </el-dialog>
    <!-- 白名单弹窗 -->
    <exchangeWhiteList
      v-if="isShowWhite"
      v-model="isShowWhite"
      :whiteRow="whiteListRow"
    />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import generate from '@/components/generate_report.vue'
import inputForm from "@/components/jhk/inputForm";
import { prefixurl } from "@/api/jhk/paradiseAndTaskCommonController.js";
import qrcodeVue from "qrcode-vue";
import crowdDialog from "../activity/crowd-Dialog.vue"
import ShowImage from './components/showImage.vue'
import integralMallDecoration from "./components/integralMallDecoration.vue"
import { getShortLink } from "@/api/jhk/marketing/shortLink";
import {
  exchangeActivityList,
  deleteActivityList,
  updateActivityList,
  inquireActivity,
  changeActivity,
  getExchangeActivityRecord,
  markingSendStatus,
  updateActivity,
  quashAddMoney
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import {
  DeliveryStatus,
  pointsExchangeQuash,
  removeUserPromoToken
} from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import statistics from "../activity/activity_data_statistics.vue";
import statisticsNew from "../activity/activity_data_statistics_new.vue";
import { querydetail,pointsExchange } from "@/api/jhk/integralCenter/couponWriteController.js";
import { getmoble, getSellerCheckCode, exportBatch,exportRecord } from "@/api/jhk/paradiseAndTaskCommonController.js";
import createCoupons from "../activity/create_coupons.vue";
import createCoupons2 from "../activity/create_coupons2.vue";
import createExchangeCashRed from "../activity/create_exchangeCashRed.vue";
import pointsMoneyPurchase from "../activity/points_money_purchase.vue";
import batchUpload from './components/batchUpload.vue'
import { getSupplierAccountList,allAccount,getGiftCardPage} from "@/api/jhk/integralCenter/prizeCenter.js";
import { customSellerLinkPage,customSellerLinkSave } from "@/api/jhk/activityController";
import createExchangeCommon from "../activity/create_exchange_common.vue";
import addPrizeNum from "@/views/interactiveMarketing/activity/components/add-prize-num.vue";
import informationForm from "@/views/interactiveMarketing/activity/components/informationForm.vue";
import exchangeWhiteList from "./components/exchangeWhiteList.vue";
export default {
  props: {
    inputShow: {
      default: true,
    },
    inputShow1: {
      default: false,
    },
    activityType: {
      default: "",
    },
    statisType: {
      default: 1,
    },
    top: {
      default: false
    }
  },
  components: {
    inputForm,
    qrcodeVue,
    generate,
    statistics,
    statisticsNew,
    createCoupons,
    createCoupons2,
    createExchangeCashRed,
    crowdDialog,
    batchUpload,
    integralMallDecoration,
    pointsMoneyPurchase,
    createExchangeCommon,
    ShowImage,
    addPrizeNum,
    informationForm,
    exchangeWhiteList,
  },
  data() {
    return {
      whiteListRow: {},
      isShowWhite: false,
      isDisabled: true,
      qrcodeDialogVisible: false, // 控制二维码弹窗显示
      qrcodePreviewData: null, // 二维码数据
      isShowIntegral: false,
      formAccount: {
        accountCode: "",
        accountType: ""
      },
      accountCode: "商家账户",
      accountCodeList:[],
      tabSwitchList: ["全部", "已上架", "待上架", "已下架"],
      tabSwitchListData: [
        { value: 0, label: "全部" },
        { value: 1, label: "进行中"},
        { value: 2, label: "未开始"},
        { value: 3, label: "已结束"},
        { value: 5, label: "草稿箱"}
      ],
      tabSwitchListDatas: [
        { value: 0, label: "默认链接" },
        { value: 1, label: "店铺渠道" },
        { value: 2, label: "自定义渠道" },
      ],
      currIndexs: 0,
      // 店铺渠道数据
      tableDatas: [],
      // 自定义渠道数据
      tableDatas2: [],
      // 渠道表格配置
      tableChannelInfo: [ // 店铺渠道链接表格配置
        {
          prop: 'sellerLinkName',
          label: '渠道名称',
          width: 280
        },
        {
          prop: 'linkUrl',
          label: '链接地址',
          slot: 'linkUrls',
          width: 280
        },
        {
          prop: 'qrCode',
          label: '二维码',
          slot: 'qrCode',
          width: 220
        },
        {
          prop: 'action',
          label: '操作',
          slot: 'action',
          width: 180,
        },
      ],
      // 二维码预览数据
      qrcodePreviewData: null,
      // 二维码预览对话框显示状态
      qrcodeDialogVisible: false,
      // 表格加载状态
      tableLodingCurrIndexOne: false,
      tableLodingCurrIndexTwo: false,
      // 显示遮罩层的二维码ID
      showMask: null,
      // 活动链接ID
      actLinkIds: '',
      currIndex: 0,
      codeMsg: "获取验证码",
      code: "",
      phone: "",
      successMsg: "",
      // timer: "",
      control: false,
      countdown: 60,
      codeDisabled: false,
      ExprotData: "",
      // 验证码
      opentime: true,
      visible: false,
      timer: null, //验证码定时
      saveDisable: false,
      //
      rowData: {},
      ids1: "",
      createStep: 1,
      qrcodeVue: {
        size: 200,
        bgColor: "#fff",
        fgColor: "#000",
        value: "https://www.baidu.com/", //二维码地址
        logo: require("@/assets/new-images/jd_logo.svg"), //logo图片
      },
      pageName: "忠诚度管理-积分商城",
      memberLevelList: [
        { value: "非会员", label: 0, point: "" },
        { value: "一星会员", label: 1, point: "" },
        { value: "二星会员", label: 2, point: "" },
        { value: "三星会员", label: 3, point: "" },
        { value: "四星会员", label: 4, point: "" },
        { value: "五星会员", label: 5, point: "" },
      ],
      talbeLoading: false,
      talbeLoading2: false,
      outerVisible: false,
      timeDay: 0, //活动持续天数
      theSta: 0,
      dialogFormVis: false,
      dialogFormBtnLoading: false,
      amendForm: {},
      couponTxt: {},
      // 表单配置项
      inputData: [
        {
          label: "礼品名称：",
          prop: "activityName",
          type: "Input",
          value: "",
          placeholder: "请填入活动名称",
        },
        {
          label: "礼品类型：",
          prop: "activityType",
          placeholder: "礼品类型",
          value: "",
          type: "Select",
          options: [
            { label: "全部", value: "" },
            { label: "兑换实物", value: 9 },
            { label: "兑换优惠券", value: 10 },
            { label: "兑换京豆", value: 29 },
            { label: "兑换E卡", value: 30 },
            { label: "兑换红包", value: 38 },
            { label: "积分加钱购", value: 55 },
            { label: "兑换爱奇艺会员", value: 58 },
            { label: "兑换PLUS会员", value: 59 },
            { label: "兑换礼品卡", value: 60 },
            { label: "兑换百度网盘", value: 61 },
          ],
        },
        {
          label: "上架状态：",
          prop: "status",
          placeholder: "上架状态",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "待上架", value: 1 },
            { label: "已上架", value: 2 },
            { label: "已下架", value: 3 },
            { label: "草稿箱", value: 5 }
          ],
        },
        {
          label: "是否在积分商城显示：",
          prop: "isDisplay",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: ""},
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        //京东1.84
        // {
        //   label: "用户pin：",
        //   prop: "pin",
        //   type: "Input",
        //   value: "",
        //   placeholder: "请填入活动名称",
        // },
      ],
      inputData1: [
        {
          label: "礼品名称",
          prop: "activityName",
          type: "Input",
          value: "",
          placeholder: "请填入活动名称",
        },
        {
          label: "上架状态",
          prop: "status",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "待上架", value: 1 },
            { label: "已上架", value: 2 },
            { label: "已下架", value: 3 },
          ],
        },
      ],
      inputData2:[
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          value: "",
          placeholder: "请填入用户昵称",
        },
        {
          label: "发货状态：",
          prop: "deliveryStatus",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "待发货", value: 1 },
            { label: "已发货", value: 2 },
            { label: "无需发货", value: 3 },
          ],
        },
        {
          label: "兑换时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startTime: "",
          endTime: ""
        },
        {
          label: "兑换状态：",
          prop: "exchangeStatus",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "兑换成功", value: 1 },
            { label: "兑换失败", value: 2 },
            { label: "领取成功", value: 3 },
            { label: "已撤回", value: 4 },
          ],
        },
        {
          label: "礼品名称：",
          prop: "prizeName",
          type: "Input",
          value: "",
          placeholder: "请填入礼品名称",
        },
        {
          label: "礼品类型：",
          prop: "activityType",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "兑换实物", value: 9 },
            { label: "兑换优惠券", value: 10 },
            { label: "兑换京豆", value: 29 },
            { label: "兑换E卡", value: 30 },
            { label: "兑换红包", value: 38 },
            { label: "积分加钱购", value: 55 },
            { label: "兑换爱奇艺会员", value: 58},
            { label: "兑换PLUS会员", value: 59 },
            { label: "兑换礼品卡", value: 60 },
            { label: "兑换百度网盘", value: 61 },
          ],
        },
        {
          label: "用户pin：",
          prop: "pin",
          type: "Input",
          value: "",
          placeholder: "请输入用户PIN",
        },
      ],
      createByMe: false,
      // 表格数据
      tableData: [],
      tableData2:[],
      // 所需积分内容展开
      tableOpenAll: false,
      pageshow: true,
      totalNum: 0,
      totalNum2: 0, 
      formList: {
        current: 1,
        size: 10,
        status: ""
      },
      formList2: {
        current: 1,
        size: 10,
      },
      status: 0,
      ids: null,
      qrcode: null,
      venderType: 0,
      activityData: {},
      valueRow:null,
      detailStatus:false,
      isShowCrowdDialog: false,
      source:"",
      sendOutGoodsForm: {
        id: "",
        billCode: "",
        isUpdatePrizeStatus: true,
        isShowCrowdDialog: false,
      },
      enterCoutierNum:"",
      sendOutGoodsShow:false,
      batchLockVisible:false,
      enterCoutierRowData:{},
      isNew:false,
      isDraftEdit:false,
      venderId:null,
      stepNum:0,
      aqyList: [
        {
          label: "月卡",
          value: '8',
          quantityBalance: 0
        },
        {
          label: "季卡",
          value: '12',
          quantityBalance: 0
        },
        {
          label: "半年卡",
          value: '13',
          quantityBalance: 0
        },
        {
          label: "年卡",
          value: '14',
          quantityBalance: 0
        },
      ],
      jdPlusList: [
        {
          label: "年卡",
          value: '7',
          quantityBalance: 0
        },
      ],
      prizeMemberList: [],
      giftCardList: [],
      laoding: false,
      activityTypeListAll:[58,59,60,61],
      activityTypeList:[58,59],
      activityTypeList1:[60,61],
      quantityBalance: 0,
      addChannelVisible: false, // 添加渠道链接弹窗
      addChanneltype: 0, // 添加渠道链接的活动类型
      channelName: "", // 新增渠道名称
      addChannelLoading: false, // 新增渠道loading
      createStep: 1,
      stepNum: 1,
      isCopy: false,
      toAddItem: {},
      isShowAddNum: false,
      // 显示配置弹窗相关
      displayConfigVisible: false, // 显示配置弹窗开关
      displayConfigSaving: false, // 保存loading
      currentDisplayRow: null, // 当前配置的行数据
      displayConfigForm: {
        displayType: 0, // 显示类型：0不显示 1持续显示 2活动结束则不显示 3指定显示时间
        displayStartTime: "", // 指定开始时间
        displayEndTime: "" // 指定结束时间
      },
      displayConfigDateRange: [] // 日期范围选择器绑定值
    };
  },
  computed: {
    backgroundOpacity() {
      return this.amendForm && this.amendForm.id ? true : false;
    },
    labelText() {
      const textType = {
        58: "爱奇艺会员面值:",
        59: "PLUS会员面值:",
        60: "选择礼品卡:",
        61: "选择百度网盘:",
      };
      return textType[this.amendForm.activityType] || "";
    },
    // 获取链接URL
    getLinkUrl() {
      return (row) => {    
        // 二维码进小程序
        let xcxUrl = this.$commonUrl();
        this.xcxUrl = this.$commonUrl();
        let options = {
          activityId: row.activityId,
          venderId: row.venderId,
          activityType: row.subType,
          id: row.activityId,
          index: 222,
          sellerLinkId: row.id
        };
        let pcParams = encodeURIComponent(
          Object.keys(options)
            .map((item) => `${item}=${options[item]}`)
            .join("&")
        );

       if (row.subType ==  9) {
         return xcxUrl + `pages/integralStore/exchange/exchange.html%3F${pcParams}`
       }
       if (row.subType == 10) {
         return xcxUrl + `pages/integralStore/discount/discount.html%3F${pcParams}`;
       }
       //  京豆、e卡
       if (row.subType == 29 || row.subType  == 30) {
        return xcxUrl + `pages/integralStore/conversionDou/conversionDou.html%3F${pcParams}`;
       }
       if(row.subType == 38){
        return xcxUrl + `pages/integralStore/exchangeHb/exchangeHb.html%3F${pcParams}`;
       }
       if(row.subType == 55){
           return xcxUrl + `pages_2/addMoneyToBuy/addMoneyToBuy.html%3F${pcParams}`;
       }
       if(row.subType == 58 || row.subType == 59 || row.subType == 60 || row.subType==61){
          return xcxUrl + `pages/integralStore/giftCard/giftCard.html%3F${pcParams}`;
       }
       if (row.subType == 65) {
             return xcxUrl + `pages_2/fansPunchCard/fansPunchCard.html%3F${pcParams}`;
       }
       // 默认返回值
      return '';
     }
    },
  },
  watch: {
    createStep(newVal) {
      if (newVal != 1) {
        this.$emit("tabChange", false);
      } else {
        this.$emit("tabChange", true);
      }
    },
    venderType:{
        handler(newVal) {
        if(newVal) {
          this.getSupplierList()
        }
      },
      immediate:true
    },
    venderId: {
      handler(newVal) {
        if(newVal&&this.venderType) {
          this.formAccount.accountCode = newVal
          this.formAccount.accountType = "1"
        }
      },
      immediate: true
    },
    accountCode:{
      handler(newVal) {
        if(newVal) {
          if(newVal=="商家账户") {
            this.formAccount.accountCode = this.venderId
            this.formAccount.accountType = "1"
          }else {
            this.formAccount.accountCode = newVal
            this.formAccount.accountType = "2"
          }
        }
      }
    },
    formList: {
      handler(newVal) {
        if(newVal.status){
          if(newVal.status == 1){
            this.currIndex = 2
          } else if(newVal.status == 2) {
            this.currIndex = 1
          } else if(newVal.status == 3){
            this.currIndex = 3
          } else if(newVal.status == 5){
            this.currIndex = 5
          }
        } else {
          this.currIndex = 0
        }
      },
      immediate:true,
      deep:true
    }
  },
  filters: {
    activityString(key) {
      let obj = {
        9: "兑换实物",
        10: "兑换优惠券",
        29: "兑换京豆",
        30: "兑换E卡",
        38: "兑换红包",
        55: "积分加钱购",
        58: "兑换爱奇艺会员",
        59: "兑换PLUS会员",
        60: "兑换礼品卡",
        61: "兑换百度网盘",
      };
      return obj[key];
    },
  },
  created() {
    if (this.$route.query.activityType) {
      this.inputData[1].value = Number(this.$route.query.activityType);
    }
    this.prefixQue();
    getmoble().then((res)=>{
      this.venderType = res.data.venderType
    })
    if(this.$route.params.isDataStatistics == true && this.$store.state.dataStatistics){
      this.statisData(this.$store.state.dataStatistics);
      this.$store.state.dataStatistics = null;
    }
  },
  mounted() {
    // this.getChangeList();
  },
  methods: {
    // 白名单
    handleWhiteList(row) {
      this.whiteListRow = row
      this.isShowWhite = true
    },
    confirmAdd(num) {
      this.isShowAddNum = false;
      this.getChangeList();
    },
    addInventory(row) {
      this.toAddItem = {
        num: row.num,
        title: row.activityName,
        activityId: row.id
      };
      this.isShowAddNum = true;
    },
    // 获取短链接
    urlChange(item, index){
      let params = {
           isJdApi:2,
           shortLinkType:1,
           isSmartLink:0,
           isPrecision:0,
           url:item
       }
       if(!item){
        return
       }
      getShortLink(params).then(res => {
        if (res.code == 1) {
           this.$set(this.tableData[index], 'shortLink', res.message);
        }
      })
    },
    // 渠道链接保存
    handleChannelSave() {
      if (!this.channelName) {
        this.$message.warning("请填写渠道名称!");
        return;
      }
      this.addChannelLoading = true
      let params = {
        sellerLinkName: this.channelName, // 名称
        activityId: this.actLinkIds?this.actLinkIds:'',
        source:1,
      }
      customSellerLinkSave(params).then((res)=>{
        this.addChannelLoading = false
        if(res.code === 1){
          this.$message.success("添加成功");
          this.addChannelVisible = false;
          // this.getChannelList();
        }else{
          this.$message.error(res.message);
        }
      })
    },
    // 获取弹窗宽度
    getPopoverWidth(type) {
      // 所有活动都使用800px宽度以适配渠道链接显示
      return 800;
    },
    getInputWidth(type) {
      // 所有活动都使用503px宽度以适配渠道链接显示
      return 503;
    },
    handlePrizeChange(val,type) {
      let newList = []
      if(type==1) {
        newList = this.prizeMemberList
      } else {
        newList = this.giftCardList
      }
      if (newList.length > 0) {
        let obj = newList.find((item) => item.value == val);
        if (obj) {
          this.quantityBalance = obj.quantityBalance;
          if(type==2) {
            this.giftCardEndTime = obj.endTime;
          }
        }
      }
    },
    //获取爱奇艺会员列表
    getPrizeMemberList(activityType) {
      const types = {
        58: 4,
        59: 3,
      };
      const activiTypes = {
        58: this.aqyList,
        59: this.jdPlusList,
      };
      return allAccount({ type: types[activityType] }).then((res) => {
        if (res.data && res.data.length > 0) {
          this.prizeMemberList = res.data.map((item, index) => {
            let obj = {
              label: "",
              value: "",
              quantityBalance: 0
            };
            obj.label = `${item.itemName}（剩余${item.quantityBalance}${item.unit}）`;
            obj.value = item.itemId;
            obj.quantityBalance = item.quantityBalance;
            return obj;
          });
        } else {
          this.prizeMemberList = activiTypes[activityType].map(
            (item, index) => {
              item.label = `${item.label}（剩余0张）`;
              return item;
            }
          );
        }
        this.amendForm.itemId = this.prizeMemberList[0].value;
        this.quantityBalance = this.prizeMemberList[0].quantityBalance;
      });
    },
    async getList(activityType) {
      try {
        const types = {
          60: "0,1",
          61: "2",
        };
        const params = {
          current: 1,
          size: 100000,
          activateTypeStr: types[activityType],
        };
        const res = await getGiftCardPage(params);
        if (res.code == 1) {
          if (res.data.records && res.data.records.length > 0) {
            this.giftCardList = res.data.records.map((item) => {
              return {
                label: item.planName,
                value: item.id,
                quantityBalance: item.quantityBalance,
              };
            });
            this.amendForm.assetsId = this.giftCardList[0].value;
            this.quantityBalance = this.giftCardList[0].quantityBalance;
          }
        }
      } catch (error) {}
    },
    // 撤回奖品（积分加钱购）
    revocationAddMoneyGoods(row) {
      this.$confirm('确定撤回用户兑奖资格？',
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          iconClass: "iconfont iconicon-jinggao1",
          customClass: "reverse-buttons",
        }
      ).then((res) => {
        quashAddMoney({
          id: row.id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("撤回奖品成功");
            this.getExchangeActivityRecord();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 移除令牌
    removeToken(row) {
      this.$confirm('确定移除用户的令牌资格？',
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          iconClass: "iconfont iconicon-jinggao1",
          customClass: "reverse-buttons",
        }
      ).then((res) => {
        removeUserPromoToken({
          id: row.id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("移除用户令牌资格成功");
            this.getExchangeActivityRecord();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 撤回发货（积分兑换）
    revocationIntergralGoods(row){
      this.$confirm(`您的订单状态为${row.deliveryStatus === 1 ? '待发货' : '已发货'}，是否进行撤回！`,"提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(res=>{
        pointsExchangeQuash({
          id: row.id
        }).then(res=>{
          if(res.code == 1){
            this.$message.success('撤回成功')
            this.getExchangeActivityRecord()
          }else{
            this.$message.success(res.message)
          }
        })
      })
    },
    handleToDecoration() {
      this.isShowIntegral = true
      this.createStep = "decoration"
    },
    // 是否在商城显示/优先级
   async handleChangeDisplayOrSort(val,row,flag) {
      let params = {
        id:row.id
      }
      if(flag=="isDisplay") {
        params.isDisplay = val
        params.sort = row.sort || 1
      } else {
        params.sort = val
        params.isDisplay = row.isDisplay
      }
      try {
        const res = await updateActivity(params)
        if(res.code==1) {
          this.$message.success(res.message)
          this.getChangeList();
        }
      } catch (error) {
        this.$message.error(res.message)
      }
    },
    // 获取显示配置按钮文案
    getDisplayConfigText(row) {
      // 读取displayRule配置对象
      const rule = row.displayRule || {};
      // 历史数据兼容：旧数据isDisplay=1但没有配置过displayRule，默认视为持续显示
      if (row.isDisplay == 1 && rule.displayType == null) {
        return '持续显示';
      }
      switch (rule.displayType) {
        case 0:
          return '不显示';
        case 1:
          return '持续显示';
        case 2:
          return '活动下架则不显示';
        case 3:
          // 指定显示时间显示日期范围
          if (rule.displayStartTime && rule.displayEndTime) {
            return `${rule.displayStartTime} 至 ${rule.displayEndTime}`;
          }
          return '指定显示时间';
        default:
          return '不显示';
      }
    },
    // 打开显示配置弹窗，回显上次配置
    openDisplayConfigDialog(row) {
      this.currentDisplayRow = row;
      // 读取displayRule配置对象
      const rule = row.displayRule || {};
      // 回显数据，兼容历史数据：isDisplay=1但没有displayRule时默认持续显示
      let displayType = rule.displayType != null ? rule.displayType : (row.isDisplay == 1 ? 1 : 0);
      this.displayConfigForm = {
        displayType: displayType,
        displayStartTime: rule.displayStartTime || '',
        displayEndTime: rule.displayEndTime || ''
      };
      // 回显日期范围选择器
      if (displayType === 3 && rule.displayStartTime && rule.displayEndTime) {
        this.displayConfigDateRange = [rule.displayStartTime, rule.displayEndTime];
      } else {
        this.displayConfigDateRange = [];
      }
      this.displayConfigVisible = true;
    },
    // 保存显示配置
    async saveDisplayConfig() {
      const { displayType } = this.displayConfigForm;
      // 构建displayRule配置对象
      let displayRule = { displayType: displayType };
      // 根据显示类型设置isDisplay和时间参数
      let isDisplay = 0;
      if (displayType === 0) {
        // 不显示：isDisplay=0
        isDisplay = 0;
      } else {
        // 其他显示类型：isDisplay=1
        isDisplay = 1;
        if (displayType === 3) {
          // 指定显示时间：校验并设置时间范围
          if (!this.displayConfigDateRange || this.displayConfigDateRange.length !== 2) {
            return this.$message.warning('请选择显示日期范围');
          }
          displayRule.displayStartTime = this.displayConfigDateRange[0];
          displayRule.displayEndTime = this.displayConfigDateRange[1];
        }
      }
      let params = {
        id: this.currentDisplayRow.id,
        sort: this.currentDisplayRow.sort || 1,
        isDisplay: isDisplay,
        displayRule: displayRule
      };
      this.displayConfigSaving = true;
      try {
        const res = await updateActivity(params);
        if (res.code == 1) {
          this.$message.success('配置保存成功');
          this.displayConfigVisible = false;
          // 刷新列表获取最新数据
          this.getChangeList();
        } else {
          this.$message.error(res.message || '保存失败');
        }
      } catch (error) {
        this.$message.error('保存失败，请重试');
      } finally {
        this.displayConfigSaving = false;
      }
    },
    // 新版本切换
    triggerVersion(val){
      this.isNew = val
    },
    async getSupplierList() {
      try {
        const res = await getSupplierAccountList()
        if(res.code==1) {
          let list = res.data
          this.accountCodeList = list.map((item)=>{
            let obj = {}
            obj['accountCode'] = item
            return obj
          })
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          })
        }else {
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          })
        }
      } catch (error) {
        
      }
    },
    handleCreateByMe() {
      this.formList.current = 1;
      this.getChangeList();
    },
    handleTab(i) {
      this.createByMe = false
      this.currIndex = i;
      if (i == 0) this.formList.status = "";
      if (i == 1) this.formList.status = 2;
      if (i == 2) this.formList.status = 1;
      if (i == 3) this.formList.status = 3;
      if (i == 5) this.formList.status = 5;
      // 草稿箱调整上架状态
      // if(i == 5){
      //   this.inputData[2].options = [{ label: "草稿箱", value: 5 }]
      // }else{
      //   this.inputData[2].options = [
      //     { label: "全部", value: "" },
      //     { label: "待上架", value: 1 },
      //     { label: "已上架", value: 2 },
      //     { label: "已下架", value: 3 },
      //   ]
      // }
      this.inputData[2].value = this.formList.status
      this.$refs["inputFormRef"].reData();
      this.getChangeList();
    },
    
    // 处理标签切换
    handleTabs(i,e) {
      this.currIndexs = i;
      this.actLinkIds = e.id;
      const params = {
        activityId: e.id,
        size: 10,
        current: 1,
        type: i
      };
      // 设置加载状态
      if (i === 1) {
        this.tableLodingCurrIndexOne = true;
      } else if (i === 2) {
        this.tableLodingCurrIndexTwo = true;
      }
      customSellerLinkPage(params).then((res) => {
        if (i === 1) {
          this.tableLodingCurrIndexOne = false;
          this.tableDatas = res.data.records || [];
        } else if (i === 2) {
          this.tableLodingCurrIndexTwo = false;
          this.tableDatas2 = res.data.records || [];
        }
      }).catch(() => {
        // 错误处理，重置加载状态
        if (i === 1) {
          this.tableLodingCurrIndexOne = false;
        } else if (i === 2) {
          this.tableLodingCurrIndexTwo = false;
        }
      });
    },
    
    // 判断是否显示渠道切换
    showCannel(type, settingType = 0) {
      // 放开所有活动的店铺渠道链接和自定义渠道链接
      // settingType 当活动仅设置了当前店铺时，也不会展示店铺渠道链接和自定义渠道链接
      return settingType === 0;
    },
    
    // 处理鼠标进入时重置标签索引
    handlerMouseEnter(){
      this.currIndexs = 0;
    },
    
    // 复制渠道链接
    copyChannelUrl(url) {
      this.$copyText(url).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },
    
    // 添加渠道链接
    handleAddChannel(type) {
      this.channelName = '';
      this.addChannelVisible = true;
      this.addChanneltype = type;
    },
    
    // 显示二维码对话框
    showQrcodeDialog(row) {
      console.log(row,'6565465645');
      
      this.qrcodePreviewData = {
        url: this.getLinkUrl(row),
        logo: this.qrcodeVue.logo,
        bgColor: this.qrcodeVue.bgColor,
        fgColor: this.qrcodeVue.fgColor,
      };
      this.qrcodeDialogVisible = true;
    },
    
    // 删除渠道链接
    handleDeleteChannel(channelId) {
      this.$confirm('确定要删除该渠道链接吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 这里需要实现删除渠道链接的API调用
        this.$message.success('删除成功');
        // 刷新自定义渠道列表
        this.handleTabs(2, { id: this.actLinkIds });
      }).catch(() => {
        // 取消删除
      });
    },
    /** 获取验证码 */
    getCodeInit() {
      if (!this.timer) {
        getSellerCheckCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "重新发送(" + this.countdown + ")";
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "获取验证码";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    savePhone(exportRemark) {
      // 删除注释
      // if (!this.code) {
      //   this.$message.warning("请输入验证码");
      //   return;
      // }
      // let params = {
      //   code: this.code,
      //   endTime: this.formList.endTime,
      //   startTime: this.formList.startTime,
      //   activityId: this.formList.activityId,
      // };
      let params = {
        ...this.formList2, exportRemark 
      }
      let typeObj = {
        1: 10,
        2: 29,
        3: 9,
        5: 30,
        8: 38
      }
      if(params.activityType && params.activityType != ''){
      params.activityType = typeObj[params.activityType]
      }
      exportRecord(params).then((res) => {
        if (res.code == 1) {
          // 删除注释
          // var blob = new Blob([res.blob]);
          // var link = document.createElement("a"); //a标签下载
          // link.href = window.URL.createObjectURL(blob);
          // link.download = "互动商城.xls";
          // link.click();
          // window.URL.revokeObjectURL(link.href);
          // this.visible = false;
          this.$message.success(res.message);
          this.control = true
        } else {
          this.$message.error(res.message);
        }
      });
    },
    async getphone() {
      // 删除注释
      this.code = "";
      const { data: res } = await getmoble();
      this.visible = true;
      this.phone = res.mobile;
      this.countdown = 60;
      this.codeDisabled = false;
      this.codeMsg = "获取验证码"; // 按钮上的文字
      this.venderType = res.venderType
      clearInterval(this.timer);
      this.timer = null;
      this.venderType = res.venderType
      // console.log(this.formDataList, 9999);
    },
    returnStep() {
      this.createStep = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.getChangeList();
    },
    returnStep1(){
      this.createStep = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.getChangeList();
      this.$emit("handleshow", true);
    },
     handleSrcImg(id, type='') {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode${id} img`);
      if(type=='channel') {
        img = document.querySelector(`#channelQrcodeDownload${id} img`);
      }else if(type=='self') {
        img = document.querySelector(`#selfQrcodeDownload${id} img`);
      }
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "huodongyulan";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    searchClick(val) {
      this.formList.activityName = val.activityName;
      this.formList.activityType = val.activityType;
      this.formList.status = val.status;
      this.formList.current = 1;
      this.getChangeList();
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
        })
        .catch((res) => {});
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //关闭弹框
    closehandleDelete() {
      // this.outerVisible = false;
      this.getChangeList();
    },
    //获取列表数据
    getChangeList() {
      this.talbeLoading = true;
      console.log(this.formList,'9999');
      if (this.inputShow1) this.formList.activityType = this.activityType;
      exchangeActivityList({...this.formList,createByMe: this.createByMe}).then((res) => {
        this.tableData.forEach((item, index) => {
          var ref = "qrcode" + item.id;
          // console.log( this.$refs[ref])
          this.$nextTick(() => {
            if(this.$refs[ref]){
              this.$refs[ref].innerHTML = "";
            }           
          });
        });
        this.talbeLoading = false;
        this.tableData = res.data.records.map((item) => {
          return {
            ...item,
            days: this.DayHours(item.startTime, item.endTime, item.status),
          };
        });
        this.totalNum = Number(res.data.total);
        this.prefixQue();
        this.tableData.forEach((item, index) => {
          let xcxUrl = this.$commonUrl(); // 正式
          let options = {
            activityId: item.id,
            venderId: this.venderId || item.venderId,
            activityType: item.activityType || item.type,
            id: item.id,
          };
          let params1 = `%7B%22activityId%22%3A%22${options.activityId}%22%2C%22venderId%22%3A%22${options.venderId}%22%2C%22activityType%22%3A${options.activityType}%2C%22id%22%3A${options.id}%7D`;
          let pcParams = encodeURIComponent(
            Object.keys(options)
              .map((item) => `${item}=${options[item]}`)
              .join("&")
          );
          // 先拼一个 idUrl，然后同时赋给 pcUrl（统一覆盖后端返回的 pcUrl，保证 venderId 正确）
          let fullUrl = "";
          if (item.activityType == 9) {
            fullUrl = xcxUrl + `pages/integralStore/exchange/exchange.html%3F${pcParams}`;
          }
          if (item.activityType == 10) {
            fullUrl = xcxUrl + `pages/integralStore/discount/discount.html%3F${pcParams}`;
          }
          //  京豆、e卡
          if (item.activityType == 29 || item.activityType == 30) {
            fullUrl = xcxUrl + `pages/integralStore/conversionDou/conversionDou.html%3F${pcParams}`;
          }
          if(item.activityType == 38){
            fullUrl = xcxUrl + `pages/integralStore/exchangeHb/exchangeHb.html%3F${pcParams}`;
          }

          if(item.activityType == 55){
            fullUrl = xcxUrl + `pages_2/addMoneyToBuy/addMoneyToBuy.html%3F${pcParams}`;
          }

          if(item.activityType == 58 || item.activityType == 59 || item.activityType == 60 || item.activityType==61){
            fullUrl = xcxUrl + `pages/integralStore/giftCard/giftCard.html%3F${pcParams}`;
          }
          // ✅ 同时覆盖 idUrl 和 pcUrl，保证 venderId 正确（用 this.venderId 兜底 item.venderId）
          item.idUrl = fullUrl;
          item.pcUrl = fullUrl;
          // 获取短链接
          console.log(item,'544544545');
          
          this.urlChange(item.pcUrl || item.idUrl, index);

          // this.$nextTick(() => {
          //   let queryId = "qrcode" + item.id;
          //   this.qrcodeAll(item.idUrl, queryId);
          // });
        });
        // console.log(this.tableData, 222222);
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.amendForm.startTime.substring(0, 10);
      daysEnd = this.amendForm.endTime.substring(0, 10);
      if (this.amendForm.endTime != "" && this.amendForm.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 = new Date(this.amendForm.endTime).getTime() - new Date(this.amendForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },
    // 表单查询
    searchForm(val) {
      this.formList.activityType = val.activityType;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.activityName = val.activityName;
      this.formList.status = val.status;
      this.formList.isDisplay = val.isDisplay;
      this.getChangeList();

      this.pageshow = false; //让分页隐藏
      this.$nextTick(() => {
        //重新渲染分页
        this.pageshow = true;
      });
    },
    handleReset() {
      this.formList.activityName = "";
      this.formList.activityType = ""
      this.inputData[1].value = ""
      this.formList.status = ""
      this.$refs["inputFormRef"].reData()
      this.getChangeList();
    },
    // 下拉框选中变化，同步上架状态触发formList watcher
    handleSelectChange({ key, val }) {
      if (key === "status") {
        this.formList.status = val;
      }
    },
    // 兑换明细表单查询
     searchForm2(val) {
      this.formList2.current = 1;
      this.formList2.size = 10;
      this.formList2.memberNick = val.memberNick;
      this.formList2.deliveryStatus = val.deliveryStatus;
      this.formList2.startTime = val.startTime;
      this.formList2.endTime = val.endTime;
      this.formList2.exchangeStatus = val.exchangeStatus;
      this.formList2.prizeName = val.prizeName;
      this.formList2.activityType  = val.activityType;
      // 用户pin字段传递给接口查询参数
      this.formList2.pin = val.pin;
      this.getExchangeActivityRecord();

      this.pageshow = false; //让分页隐藏
      this.$nextTick(() => {
        //重新渲染分页
        this.pageshow = true;
      });
    },
    // 获取兑换明细数据
    getExchangeActivityRecord(){
      this.talbeLoading2 = true;
      let params = {
        ...this.formList2,
        dataFrom:2,
        venderId:this.venderId
      }
      // console.log("1234646")
      //   let typeObj = {
      //   1: 10,
      //   2: 29,
      //   3: 9,
      //   5: 30,
      //   8: 38
      //   }
      // if(params.activityType && params.activityType != ''){
      //   params.activityType = typeObj[params.activityType];
      // }
      
      getExchangeActivityRecord(params).then((res) => {
        this.talbeLoading2 = false;
        this.tableData2 = res.data.records
        this.totalNum2 = Number(res.data.total);
      });
    },
    //修改
   async changeList(row) {
      this.theSta = 0;
      this.dialogFormVis = true;
      let id = row.id;
      if(this.activityTypeList.includes(row.activityType)){
        await this.getPrizeMemberList(row.activityType)
      } else if(this.activityTypeList1.includes(row.activityType)) {
        await this.getList(row.activityType)
      }
      this.laoding = true
      inquireActivity(id)
        .then((res) => {
          this.laoding = false
          res.data.ruleDTO = res.data.ruleDTO || {
            activityTargetType: '1',
            partner: ["-1"],
            allowLevel: "-1",
            plusObject: 0,
            crowdIds: "",
            firstOpenCardTimeType: 0,
            openCardBeforeDay: "",
            orderCompleteLimitCount: "",
            orderCompleteMaxCount: "",
            orderCompleteLimitPayment: "",
            orderCompleteMaxPayment: "",
            lastOrderCompleteTimeType: 0,
            lastOrderCompleteStartDay: "",
            lastOrderCompleteEndDay: "",
            lastOrderCompleteStartTime: "",
            lastOrderCompleteEndTime: "",
            isCheckOpenCardTime: "",
            openCardStartTime: "",
            openCardEndTime: "",
          }
          res.data.ruleDTO.activityTargetType = String(res.data.ruleDTO.activityTargetType);
          res.data.peopleSelected = res.data.ruleDTO.crowdIds ? res.data.ruleDTO.crowdIds.split(',') : [];
          res.data.ruleDTO.partner = res.data.ruleDTO.allowLevel.split(",");
          res.data.ruleDTO.condFollow = res.data.ruleDTO.condFollow ? true : false;
          res.data.ruleDTO.studentSatus = res.data.studentSatus || '';
          res.data.customerPaperwork = res.data.customerPaperwork ? JSON.parse(res.data.customerPaperwork) : {};
          this.amendForm = res.data;
          this.accountCode = this.amendForm.accountCode
          this.formAccount.accountCode = this.amendForm.accountCode
          this.formAccount.accountType = this.amendForm.accountType
          this.memberLevelList = [];
          this.amendForm.memberLevelPointsDTOList.forEach((item) => {
            if (item.allow == true) {
              this.memberLevelList.push(item);
            }
          });
          // });
          if (res.data.exchangeTimes < 0) {
            this.amendForm.exchangeTimes = null;
          }
          if (res.data.activityType == 30||this.activityTypeListAll.includes(res.data.activityType)) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayTimes == -1 ? "" : res.data.exchangeDayTimes;
            this.amendForm.exchangeNum = res.data.exchangeTimes == -1 ? "" : res.data.exchangeTimes;
            // this.amendForm.itemId = res.data.itemId * 1;
          }
          if (res.data.activityType == 29) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayNum == -1 ? "" : res.data.exchangeDayNum;
            this.amendForm.exchangeNum = res.data.exchangeNum == -1 ? "" : res.data.exchangeNum;
            this.amendForm.limitVal = res.data.ruleType == 1 ? res.data.exchangeDayTimes : res.data.exchangeTimes;
          }

          this.activityTimeChange();
          // console.log(res.data, this.memberLevelList, 111);
          this.couponTxt = {};
          if (this.amendForm.activityType == 10 && this.venderType == 0) {
            querydetail(Number(this.amendForm.couponId))
              .then((res) => {
                this.couponTxt = res.data;
                this.couponTxt.beginTime = this.couponTxt.beginTime.substring(0, 10);
                this.couponTxt.endTime = this.couponTxt.endTime.substring(0, 10);
              })
              .catch((res) => {});
          }
        })
        .catch((res) => {
          this.laoding = false
        });
    },
    modify(row, type = "edit") {
      // 只适用编辑
     if (row.activityType == 9){//兑换实物    
        this.createStep = 13;
        let coverSrc = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/";
        this.activityData = {
          id: 9,
          name: "积分兑换实物",
            telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/sw.png",
            telCode: coverSrc + "sw.png",
            singleCopy: false,
            isEdit: type=='edit',
            activityType: row.activityType
        };
        this.valueRow = {
          id:row.id,
          status: row.status
        }
      } 
    },
    //修改确定
    dialogFormVisB() {
      let obj = {
        activityName: this.amendForm.activityName,
        activityType: Number(this.amendForm.activityType),
        id: Number(this.amendForm.id),
        ruleDescription: this.amendForm.ruleDescription,
        customerPaperwork: JSON.stringify(this.amendForm.customerPaperwork),
      };
      let editApi = changeActivity;
      if(this.amendForm.status == 2) {
        editApi = updateActivity;
      }
      this.dialogFormBtnLoading = true;
      editApi(obj)
        .then((res) => {
          this.dialogFormBtnLoading = false;
          if (res && res.id || res.code == 1) {
            this.dialogFormVis = false;
            this.getChangeList();
            this.$message.success("修改成功");
          } else {
            this.$message.error("修改失败");
          }
        })
        .catch((res) => {
          console.error(res);
          this.dialogFormVis = false;
          this.dialogFormBtnLoading = false;
        });
    },
    //查看
   async seeList(row,type,copy = false,isDraft = false) {
      this.theSta = 1;
      // 复制草稿箱
      if(copy || isDraft){
        let coverSrc = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/";
        this.isDraftEdit = isDraft
        let activityData = {}
        let createStep;
        switch(type){
          case 9:
            createStep = 13;
            activityData = {
              id: 9,
              name: "积分兑换实物",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/sw.png",
              telCode: coverSrc + "sw.png",
              singleCopy:copy,
              activityType: type
            };
          break;
          case 10:
            createStep = 13;
            activityData = {
              id: 10,
              name: "积分兑换优惠券",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/yhq.png",
              telCode: coverSrc + "yhq.png",
              singleCopy:copy,
              activityType: type
            };
          break;
          case 29:
          createStep = 14;
          activityData = {
            id: 29,
            name: "积分兑换京豆",
            telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/jd.png",
            telCode: coverSrc + "sw.png",
            singleCopy:copy,
            activityType: type
          };
          break;
          case 30:
            createStep = 14;
            activityData = {
              id: 30,
              name: "积分兑换E卡",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/Ek.png",
              telCode: coverSrc + "yhq.png",
              singleCopy:copy,
              activityType: type
            };
          break;
          case 38:
            createStep = 38;
            activityData = {
              id: 38,
              name: "积分兑换红包",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/dhhb.png",
              telCode: coverSrc + "dhhb.png",
              singleCopy:copy
            };
          break;
          case 55:
            createStep = 55;
            activityData = {
              id: 55,
              name: "积分加钱购",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/dhhb.png",
              telCode: coverSrc + "dhhb.png",
              singleCopy:copy
            };
          break;
          case 58:
            createStep = 58;
            activityData = {
              id: 58,
              name: "积分兑换爱奇艺会员",
              singleCopy:copy,
              activityType: type
            };
          break;
          case 59:
            createStep = 59;
            activityData = {
              id: 59,
              name: "积分兑换PLUS会员",
              singleCopy:copy,
              activityType: type
            };
          break;
          case 60:
            createStep = 60;
            activityData = {
              id: 60,
              name: "积分兑换礼品卡",
              telImg: "http://cdn-image.yucrm.cn/images/Preview/dhcommon-prize-big.png",
              telCode: coverSrc + "dhcommon-prize-big.png",
              singleCopy:copy,
              activityType: type
            };
          break;
          case 61:
            createStep = 61;
            activityData = {
              id: 61,
              name: "积分兑换百度网盘",
              telImg: "http://cdn-image.yucrm.cn/images/Preview/dhcommon-prize-big.png",
              telCode: coverSrc + "dhcommon-prize-big.png",
              singleCopy:copy,
              activityType: type
            };
          break;
        }
        this.createStep = createStep
        this.activityData = activityData;
        this.$forceUpdate();
        this.stepNum = isDraft?1:0
        this.valueRow = {
          id:row.id,
          status: row.status
        }
      }else{
        this.dialogFormVis = true;
        if(this.activityTypeList.includes(row.activityType)){
          await this.getPrizeMemberList(row.activityType)
        } else if(this.activityTypeList1.includes(row.activityType)) {
          await this.getList(row.activityType)
        }
        this.laoding = true
        inquireActivity(row.id)
        .then((res) => {
          this.laoding = false
          res.data.ruleDTO = res.data.ruleDTO || {
            activityTargetType: '1',
            partner: ["-1"],
            allowLevel: "-1",
            plusObject: 0,
            crowdIds: "",
            firstOpenCardTimeType: 0,
            openCardBeforeDay: "",
            orderCompleteLimitCount: "",
            orderCompleteMaxCount: "",
            orderCompleteLimitPayment: "",
            orderCompleteMaxPayment: "",
            lastOrderCompleteTimeType: 0,
            lastOrderCompleteStartDay: "",
            lastOrderCompleteEndDay: "",
            lastOrderCompleteStartTime: "",
            lastOrderCompleteEndTime: "",
            isCheckOpenCardTime: "",
            openCardStartTime: "",
            openCardEndTime: "",
          }
          res.data.ruleDTO.activityTargetType = String(res.data.ruleDTO.activityTargetType);
          res.data.peopleSelected = res.data.ruleDTO.crowdIds ? res.data.ruleDTO.crowdIds.split(',') : [];
          res.data.ruleDTO.partner = res.data.ruleDTO.allowLevel.split(",");
          res.data.ruleDTO.condFollow = res.data.ruleDTO.condFollow ? true : false;
          this.amendForm = res.data;
          this.memberLevelList = [];
          this.amendForm.memberLevelPointsDTOList.forEach((item) => {
            if (item.allow == true) {
              this.memberLevelList.push(item);
            }
          });
          // });
          if (res.data.exchangeTimes < 0) {
            this.amendForm.exchangeTimes = null;
          }
          if (res.data.activityType == 30||this.activityTypeListAll.includes(res.data.activityType)) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayTimes == -1 ? "" : res.data.exchangeDayTimes;
            this.amendForm.exchangeNum = res.data.exchangeTimes == -1 ? "" : res.data.exchangeTimes;
            // this.amendForm.itemId = res.data.itemId * 1;
          }
          if (res.data.activityType == 29) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayNum == -1 ? "" : res.data.exchangeDayNum;
            this.amendForm.exchangeNum = res.data.exchangeNum == -1 ? "" : res.data.exchangeNum;
            this.amendForm.limitVal = res.data.ruleType == 1 ? res.data.exchangeDayTimes : res.data.exchangeTimes;
          }

          if(res.data.activityType == 38){
            this.amendForm.exchangeDayTimes=res.data.exchangeDayTimes
            this.amendForm.exchangeTimes=res.data.exchangeTimes
            this.amendForm.exchangeNum=res.data.exchangeNum
            this.amendForm.exchangeDayNum=res.data.exchangeDayNum
            this.amendForm.redPacketExpiration=res.data.redPacketExpiration
            this.amendForm.effectiveDays=Number(res.data.effectiveDays)
            if(res.data.redPacketExpiration == 1){
              this.amendForm.effectiveStartTime=res.data.startTime
              this.amendForm.effectiveEndTime=res.data.effectiveEndTime
            }
          }
          this.activityTimeChange();
          this.couponTxt = {};
          if (this.amendForm.activityType == 10) {
            if (this.amendForm.externalCouponId) {
              pointsExchange(Number(this.amendForm.externalCouponId))
                .then((res) => {
                this.couponTxt = res.data;
                this.couponTxt.beginTime = this.couponTxt.beginTime.substring(0, 10);
                this.couponTxt.endTime = this.couponTxt.endTime.substring(0, 10);
              })
              .catch((res) => {
              });
            }else{
                querydetail(Number(this.amendForm.couponId))
                .then((res) => {
                  this.laoding = false
                  this.couponTxt = res.data;
                  this.couponTxt.beginTime = this.couponTxt.beginTime.substring(0, 10);
                  this.couponTxt.endTime = this.couponTxt.endTime.substring(0, 10);
                })
                .catch((res) => {
                });
            }
          }
        })
      }
    },
    // 数据统计
    statisData(row) {
      if (this.statisType == 1) {
        this.rowData = row;
        this.ids1 = row.id;
        this.createStep = 3;
        // 判断活动时间是否为新版
        this.isNew = this.isCurrentTimeAfter(row.updateTime)
      } else {
        this.$emit("statisDataCreate", row);
      }
    },

    amendTheList() {},
    //删除
    deleteById(row) {
      this.ids = Number(row.id);
      this.$confirm('是否删除活动？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        this.handleDeleteTable();
      }).catch(() => {
        this.closehandleDelete();
      })
      // this.outerVisible = true;
    },
    handleDeleteTable() {
      let id = this.ids;
      deleteActivityList(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success(res.message);
            this.getChangeList();
          } else {
            this.$message.error(res.message);
          }
          // this.outerVisible = false;
        })
        .catch((res) => {});
    },
    //上下架
    updateList(row) {
      if (row.status == 1) {
        this.status = 2;
      } else if (row.status == 2) {
        this.status = 3;
      }
      let list = {
        id: Number(row.id),
        status: Number(this.status),
      };
      console.log(list);
      updateActivityList(list)
        .then((res) => {
          console.log(res);
          if (res && res.code == 1) {
            this.$message.success(res.message);
            this.getChangeList();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          // console.log(res, "res");
          // this.$message.error(res.message);
        });
    },
    DayHours(start, end, status) {
      // let startTime = new Date(start);
      // let endTime = new Date(end);
      let nowTime = this.formatDate(new Date());
      let res = "";
      // 未开始
      if (status == 1) {
        let arr = this.timediff(start, nowTime);
        res = arr[0] + "天" + arr[1] + "小时" + arr[2] + "分后开始";
      }
      // 进行中
      if (status == 2) {
        let arr = this.timediff(start, nowTime);
        res = "活动持续了" + arr[0] + "天" + arr[1] + "小时" + arr[2] + "分";
      }
      // 已结束
      if (status == 3) {
        let arr = this.timediff(start, end);
        res = "活动持续了" + arr[0] + "天" + arr[1] + "小时" + arr[2] + "分";
      }
      return res;
    },
    timediff(begin_time, end_time) {
      //年月日时分秒转换为时间戳
      let beginTime = new Date(begin_time).getTime() / 1000;
      let endTime = new Date(end_time).getTime() / 1000;
      var starttime = "";
      var endtime = "";
      if (beginTime < endTime) {
        starttime = beginTime;
        endtime = endTime;
      } else {
        starttime = endTime;
        endtime = beginTime;
      }
      //计算天数
      var timediff = endtime - starttime;
      var days = parseInt(timediff / 86400);
      //计算小时数
      var remain = timediff % 86400;
      var hours = parseInt(remain / 3600);
      //计算分钟数
      var remain = remain % 3600;
      var mins = parseInt(remain / 60);
      // var res = days + "天" + hours + "小时" + mins + "分";
      return [days, hours, mins];
    },
    formatDate(date, fmt = "yyyy-MM-dd hh:mm:ss") {
      let currentDate = new Date(date);
      let o = {
        "M+": currentDate.getMonth() + 1, //月份
        "d+": currentDate.getDate(), //日
        "h+": currentDate.getHours(), //小时
        "m+": currentDate.getMinutes(), //分
        "s+": currentDate.getSeconds(), //秒
        "q+": Math.floor((currentDate.getMonth() + 3) / 3), //季度
        S: currentDate.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (currentDate.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      return fmt;
    },
    handlePages(page) {
      this.formList.current = page.pageNum;
      this.formList.size = page.pageSize;
      this.getChangeList();
    },
    handlePages2(page) {
      this.formList2.current = page.pageNum;
      this.formList2.size = page.pageSize;
      this.getExchangeActivityRecord();
    },
    // 兑换明细
    detailClick(){
      this.detailStatus = !this.detailStatus
      if(this.detailStatus){
        this.$nextTick(()=>{
          this.$refs["detailFormRef"].reData()
        })
        this.getExchangeActivityRecord()
      }
    },
    // 按查询结果生成人群
    addCrowd(val){
      this.source = val
      this.isShowCrowdDialog = true
    },
    // 关闭
    crowdClose(){
      this.isShowCrowdDialog = false
    },
    // 关闭录入快递单号
    blankEnterCoutierNum() {
      this.enterCoutierNum = "";
      // 清除当前行存储数据
      this.enterCoutierRowData = {};
      this.sendOutGoodsShow = false;
    },
    // 发货信息确定
    goodsEnterCoutierSubmit() {
      let params = {
        recordId: this.enterCoutierRowData.id,
        billCode: this.enterCoutierNum,
        // 这里默认传true
        isUpdatePrizeStatus: true,
      }
      markingSendStatus(params).then((res) => {
        if(res.code == 1){
          // 标记发货
            // 置空录入快递单号输入框
            this.blankEnterCoutierNum();
            this.$message.success("录入快递单号成功");
            // 刷新列表
            this.getExchangeActivityRecord();
          // });
        }else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$message.error("录入快递单号失败");
      })
    },
    // 批量标记发货
    batchMarkForShipment(){
      this.batchLockVisible = true
    },
    // 关闭批量标记发货
    batchLockClose(){
      this.batchLockVisible = false
    },
    //标记发货
    changeShip(row) {
      this.$confirm("是否标记为发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        DeliveryStatus(row.id,1)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success(res.message);
              this.getExchangeActivityRecord();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    // 取消发货
    cancelShip(row){
      this.$confirm("是否取消发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        DeliveryStatus(row.id,1)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success('取消发货成功');
              this.getExchangeActivityRecord();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    // 录入快递单号
    shipment(row){
      this.enterCoutierRowData = row
      this.sendOutGoodsShow = true
    },
    // 点击解密
    handleDecrypt1(name, item, index) {
      let params = "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      this.$decrypt.decryptJHK({ decryptContent: item[`${params}`] }).then((res) => {
        this.tableData2[index][`${name}`] = res.message;
      });
    },
    // 编辑草稿箱
    editDraft(row){
      this.seeList(row,row.activityType,false,true)
    }
  },
};
</script>

<style scoped lang="scss">
/* 显示配置文本按钮：支持日期超出自动换行 */
.display-config-btn {
  white-space: normal !important;
  word-break: break-all;
  text-align: left;
  line-height: 1.4;
  padding: 0;
  height: auto;
}
/* 显示时间单选框：两列对齐布局 */
.display-time-radios {
  display: grid;
  grid-template-columns: 160px 180px;
  gap: 8px 0;
  .el-radio {
    margin-right: 0;
  }
}
.backBtn {
  margin-left: 20px;
  width: 98px;
  height: 32px;
  color: #666666;
  border-radius: 3px;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background: rgba(254, 77, 69, 0.1);
  }
  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background: rgba(254, 77, 69, 0.1);
  }
}
.top-wrap{
  display: flex;
  align-items: center;
  justify-content: space-between;
  &-left{
    display: flex;
    align-items: center;
  }
}
.keepBtn {
  width: 98px;
  height: 32px;
  border-radius: 3px;
  background-color: #fe4d45;
  color: #fff;
  &:hover {
    opacity: 0.9;
  }
}
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: center;
  }
}
/deep/.el-radio__label {
  font-size: 12px;
}
.tabSwitch {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  // padding: 0 20px;
  margin-bottom: 24px;
  position: relative;
  height: 50px;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #f6f6f6;
  &-wz {
    height: 50px;
    line-height: 50px;
    position: relative;
    margin-right: 24px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .active {
    color: #fe4d45;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 100%;
      height: 2px;
      background-color: #fe4d45;
      transition: all 0.2s;
      animation: opation 0.2s;
    }
    @keyframes opation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 100%;
      }
    }
  }
}
.topbox {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.gift_list {
  height: 100%;
   overflow-y: auto;
  // margin-top: 24px;
  box-sizing: border-box;
  // background: #fff;
  // padding: 0 24px 24px;
  font-size: 12px !important;
  .activityName {
    display: flex;
    align-items: center;
    font-size: 14px;
    .code {
      margin-right: 4px;
      cursor: pointer;
    }
  }
  .pContent {
    float: left;
    width: 250px;
    color: #999999;
    .spanContent {
      color: #000000;
    }
  }
  .couponContent {
    height: 130px;
    width: 260px;
    border: 1px solid #dddddd;
    border-radius: 10px;
    position: relative;
    .txtNum {
      position: absolute;
      margin: 25px;
      width: 160px;
    }
    .txtSize {
      margin: 20px 0 0 140px;
    }
    .time {
      font-size: 12px;
      margin-left: 30px;
      color: #999999;
    }
    .btn {
      display: none;
      opacity: 0;
    }
  }
  .isLevelSet {
    // display: flex;
    .levelList {
      display: flex;
      flex-wrap: wrap;
      width: 450px;
      .item {
        // text-align: right;
        margin-bottom: 16px;
        font-size: 12px;
        color: #333;
      }
    }
  }
  .limitBox {
    .desc {
      font-size: 13px;
      color: #999;
      i {
        color: #fe8f8a;
        opacity: 0.8;
      }
    }
  }
  .activityTime {
    display: flex;
    flex-direction: column;
  }
  .activityTime2{
    display: flex;
    align-items: center;
    &_line{
      margin: 0px 10px;
    }
  }
  .open,
  .stop {
    color: #2768FF;
    cursor: pointer;
  }
  .tooltip {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hoveTitleShowMore {
    width: 90%;
  }
  .editList {
    width: 100%;
    display: flex;
    align-items: center;
    span {
      cursor: pointer;
    }
    .edit,
    .count {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #fe4d45;
      }
    }
    .end,
    .delete {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #fe4d45;
      }
    }
  }
  .y1,
  .y2,
  .y3 {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .y1 {
    background-color: #cccccc;
  }
  .y2 {
    background-color: #7f85e9;
  }
  .y3 {
    background-color: #fe4d45;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
  .buttonBox {
    .b1 {
      width: 98px;
      height: 32px;
      color: #666666;
      // position: absolute;
      border-radius: 3px;
      margin-top: 20px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .b2 {
      width: 98px;
      // position: absolute;
      // margin-right: 80px;
      height: 32px;
      margin: 20px 80px 10px 10px;
      border: 1px solid #fe4d45;
      color: #ffffff;
      border-radius: 3px;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
}
.open {
  position: relative;

  .openHover {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: #2768ff;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    display: none;
    cursor: pointer;
    border-radius: 4px;
  }

  &:hover {
    .openHover {
      display: flex;
      // display: none;
    }
  }
}
.mt12 {
  margin-top: 12px;
}
.mt16 {
  margin-top: 16px;
}
.mr14 {
  margin-right: 14px;
}
.mr4 {
  margin-right: 4px;
}
.ml14 {
  margin-left: 14px;
}
.disabled-btn {
  font-size: 14px;
  color: #cccccc;
}

.fc3 {
  font-size: 12px;
  color: #333;
}

.fs12 {
  font-size: 12px !important;
}

.tokenDetial-item {
  display: flex;
  align-items: center;
  margin-top: 18px;
  color: #666;
  & > span {
    width: 100px;
    display: flex;
    justify-content: right;
  }
}

.channelBox {
  height: 356px;
  overflow: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 和 Edge */
}

.channelBox::-webkit-scrollbar {
  display: none;
}

/* 二维码容器 */
.qrcode-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

/* 遮罩层 */
.qrcode-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* 放大镜图标 */
.qrcode-zoom-icon {
  font-size: 24px;
  color: white;
}

/* 二维码弹窗样式 */
.el-dialog__body {
  padding: 20px;
}

.activityManage {
  box-sizing: border-box;
  // background: #fff;
  // padding: 0 24px 24px;
  .activityName {
    display: flex;
    align-items: center;
    font-size: 14px;
    .code {
      margin-left: 8px;
      cursor: pointer;
      width: 20px;
      height: 20px;
      margin-top: 6px;
    }
    .act-name {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; //设置超出几行省略内容 
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 12px;
    }
  }
  .activityTime {
    display: flex;
    flex-direction: column;
  }
  .activityTime2 {
    display: flex;
    align-items: center;
    &_line {
      margin: 0px 10px;
    }
  }
  .state {
    padding: 6px 10px;
    border-radius: 17px;
  }
  .y1 {
    color: #666666;
    // background-color: #e6f7ff;
  }
  .y2 {
    color: #666666;
    // background: #fef1ec;
  }
  .y3 {
    color: #666666;
    // background: #f1f1f1;
  }
  .y-icon {
    width: 14px;
    height: 14px;
    margin-top: 2px;
    // margin-right: 3px;
    float: left;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .editList {
    width: 100%;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    text-align: left;
    span {
      // flex: 1;
      min-width: 28px;
      cursor: pointer;
      font-size: 14px;
    }
    .edit,
    .count {
      cursor: pointer;
      color: #2768ff;
      // &:hover {
      //   color: #fe4d45;
      // }
    }
    .end,
    .delete {
      cursor: pointer;
      color: #2768ff;
      text-align: center;
      &:hover {
        color: #5286ff;
      }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
.buttonBox {
  margin-top: 6px;
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
  .code {
      margin-left: 8px;
      cursor: pointer;
      width: 20px;
      height: 20px;
      margin-top: 6px;
    }
    .w260 {
  width: 260px;
}
</style>
